var items = {
  "block.minecraft.acacia_button": "Akasieknapp",
  "block.minecraft.acacia_door": "Akasiedỳr",
  "block.minecraft.acacia_fence": "Akasiegard",
  "block.minecraft.acacia_fence_gate": "Akasiegrind",
  "block.minecraft.acacia_hanging_sign": "Hangande akasieskilt",
  "block.minecraft.acacia_leaves": "Akasielauv",
  "block.minecraft.acacia_log": "Akasiestomn",
  "block.minecraft.acacia_planks": "Akasiebord",
  "block.minecraft.acacia_pressure_plate": "Akasie-tyngdarfjøl",
  "block.minecraft.acacia_sapling": "Akasierenning",
  "block.minecraft.acacia_shelf": "Akasiehylla",
  "block.minecraft.acacia_sign": "Akasieskilt",
  "block.minecraft.acacia_slab": "Akasiehella",
  "block.minecraft.acacia_stairs": "Akasietropp",
  "block.minecraft.acacia_trapdoor": "Akasielem",
  "block.minecraft.acacia_wall_hanging_sign": "Hangande akasieskilt på vegg",
  "block.minecraft.acacia_wall_sign": "Akasieveggskilt",
  "block.minecraft.acacia_wood": "Akasievìd",
  "block.minecraft.activator_rail": "Åslagarskjena",
  "block.minecraft.air": "Vind",
  "block.minecraft.allium": "Villauk",
  "block.minecraft.amethyst_block": "Ametystblokk",
  "block.minecraft.amethyst_cluster": "Ametystklyngja",
  "block.minecraft.ancient_debris": "Forne leiver",
  "block.minecraft.andesite": "Andesitt",
  "block.minecraft.andesite_slab": "Andesitthella",
  "block.minecraft.andesite_stairs": "Andesitttropp",
  "block.minecraft.andesite_wall": "Andesittvegg",
  "block.minecraft.anvil": "Sted",
  "block.minecraft.attached_melon_stem": "Fest melonstylk",
  "block.minecraft.attached_pumpkin_stem": "Fest graskjerstylk",
  "block.minecraft.azalea": "Lyngrosa",
  "block.minecraft.azalea_leaves": "Lauv av lyngrosetre",
  "block.minecraft.azure_bluet": "Houstonia",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblokk",
  "block.minecraft.bamboo_button": "Bambusknapp",
  "block.minecraft.bamboo_door": "Bambusdỳr",
  "block.minecraft.bamboo_fence": "Bambusgard",
  "block.minecraft.bamboo_fence_gate": "Bambusgrind",
  "block.minecraft.bamboo_hanging_sign": "Hangande bambusskilt",
  "block.minecraft.bamboo_mosaic": "Bambusmosaikk",
  "block.minecraft.bamboo_mosaic_slab": "Hella av bambusmosaikk",
  "block.minecraft.bamboo_mosaic_stairs": "Tropp av bambusmosaikk",
  "block.minecraft.bamboo_planks": "Bambusbord",
  "block.minecraft.bamboo_pressure_plate": "Bambus-tyngdarfjøl",
  "block.minecraft.bamboo_sapling": "Bambusskot",
  "block.minecraft.bamboo_shelf": "Bambushylla",
  "block.minecraft.bamboo_sign": "Bambusskilt",
  "block.minecraft.bamboo_slab": "Bambushella",
  "block.minecraft.bamboo_stairs": "Bambustropp",
  "block.minecraft.bamboo_trapdoor": "Bambuslem",
  "block.minecraft.bamboo_wall_hanging_sign": "Hangande bambusskilt på vegg",
  "block.minecraft.bamboo_wall_sign": "Bambusveggskilt",
  "block.minecraft.banner.base.black": "Svart botn",
  "block.minecraft.banner.base.blue": "Blå botn",
  "block.minecraft.banner.base.brown": "Brun botn",
  "block.minecraft.banner.base.cyan": "Blågrøn botn",
  "block.minecraft.banner.base.gray": "Grå botn",
  "block.minecraft.banner.base.green": "Grøn botn",
  "block.minecraft.banner.base.light_blue": "Ljosblå botn",
  "block.minecraft.banner.base.light_gray": "Ljosgrå botn",
  "block.minecraft.banner.base.lime": "Limegrøn botn",
  "block.minecraft.banner.base.magenta": "Ljosblåraud botn",
  "block.minecraft.banner.base.orange": "Ljosbrandgul botn",
  "block.minecraft.banner.base.pink": "Ljosraud botn",
  "block.minecraft.banner.base.purple": "Blåraud botn",
  "block.minecraft.banner.base.red": "Raud botn",
  "block.minecraft.banner.base.white": "Kvit botn",
  "block.minecraft.banner.base.yellow": "Gul botn",
  "block.minecraft.banner.border.black": "Svart bord",
  "block.minecraft.banner.border.blue": "Blått bord",
  "block.minecraft.banner.border.brown": "Brunt bord",
  "block.minecraft.banner.border.cyan": "Blågrønt bord",
  "block.minecraft.banner.border.gray": "Grått bord",
  "block.minecraft.banner.border.green": "Grønt bord",
  "block.minecraft.banner.border.light_blue": "Ljosblått bord",
  "block.minecraft.banner.border.light_gray": "Ljosgrått bord",
  "block.minecraft.banner.border.lime": "Ljosgrønt bord",
  "block.minecraft.banner.border.magenta": "Ljosblåraudt bord",
  "block.minecraft.banner.border.orange": "Brandgult bord",
  "block.minecraft.banner.border.pink": "Ljosraudt bord",
  "block.minecraft.banner.border.purple": "Blåraudt bord",
  "block.minecraft.banner.border.red": "Raudt bord",
  "block.minecraft.banner.border.white": "Kvitt bord",
  "block.minecraft.banner.border.yellow": "Gult bord",
  "block.minecraft.banner.bricks.black": "Svart tiglmynster",
  "block.minecraft.banner.bricks.blue": "Blått tiglmynster",
  "block.minecraft.banner.bricks.brown": "Brunt tiglmynster",
  "block.minecraft.banner.bricks.cyan": "Blågrønt tiglmynster",
  "block.minecraft.banner.bricks.gray": "Grått tiglmynster",
  "block.minecraft.banner.bricks.green": "Grønt tiglmynster",
  "block.minecraft.banner.bricks.light_blue": "Ljosblått tiglmynster",
  "block.minecraft.banner.bricks.light_gray": "Ljosgrått tiglmynster",
  "block.minecraft.banner.bricks.lime": "Ljosgrønt tiglmynster",
  "block.minecraft.banner.bricks.magenta": "Ljosblåraudt tiglmynster",
  "block.minecraft.banner.bricks.orange": "Brandgult tiglmynster",
  "block.minecraft.banner.bricks.pink": "Ljosraudt tiglmynster",
  "block.minecraft.banner.bricks.purple": "Blåraudt tiglmynster",
  "block.minecraft.banner.bricks.red": "Raudt tiglmynster",
  "block.minecraft.banner.bricks.white": "Kvitt tiglmynster",
  "block.minecraft.banner.bricks.yellow": "Gult tiglmynster",
  "block.minecraft.banner.circle.black": "Svòrt skiva",
  "block.minecraft.banner.circle.blue": "Blått tiglmynster",
  "block.minecraft.banner.circle.brown": "Brun skiva",
  "block.minecraft.banner.circle.cyan": "Blågrøn skiva",
  "block.minecraft.banner.circle.gray": "Grå skiva",
  "block.minecraft.banner.circle.green": "Grøn skiva",
  "block.minecraft.banner.circle.light_blue": "Ljosblå skiva",
  "block.minecraft.banner.circle.light_gray": "Ljosgrå skiva",
  "block.minecraft.banner.circle.lime": "Ljosgrøn skiva",
  "block.minecraft.banner.circle.magenta": "Ljosblåraud skiva",
  "block.minecraft.banner.circle.orange": "Brandgul skiva",
  "block.minecraft.banner.circle.pink": "Ljosraud skiva",
  "block.minecraft.banner.circle.purple": "Blåraud skiva",
  "block.minecraft.banner.circle.red": "Raud skiva",
  "block.minecraft.banner.circle.white": "Kvit skiva",
  "block.minecraft.banner.circle.yellow": "Gul skiva",
  "block.minecraft.banner.creeper.black": "Svart creeper",
  "block.minecraft.banner.creeper.blue": "Blå creeper",
  "block.minecraft.banner.creeper.brown": "Brun creeper",
  "block.minecraft.banner.creeper.cyan": "Blågrøn creeper",
  "block.minecraft.banner.creeper.gray": "Grå creeper",
  "block.minecraft.banner.creeper.green": "Grøn creeper",
  "block.minecraft.banner.creeper.light_blue": "Ljosblå creeper",
  "block.minecraft.banner.creeper.light_gray": "Ljosgrå creeper",
  "block.minecraft.banner.creeper.lime": "Ljosgrøn creeper",
  "block.minecraft.banner.creeper.magenta": "Ljosblåraud creeper",
  "block.minecraft.banner.creeper.orange": "Brandgul creeper",
  "block.minecraft.banner.creeper.pink": "Ljosraud creeper",
  "block.minecraft.banner.creeper.purple": "Blåraud creeper",
  "block.minecraft.banner.creeper.red": "Raud creeper",
  "block.minecraft.banner.creeper.white": "Kvit creeper",
  "block.minecraft.banner.creeper.yellow": "Gul creeper",
  "block.minecraft.banner.cross.black": "Svart andreskross",
  "block.minecraft.banner.cross.blue": "Blå andreskross",
  "block.minecraft.banner.cross.brown": "Brun andreskross",
  "block.minecraft.banner.cross.cyan": "Blågrøn andreskross",
  "block.minecraft.banner.cross.gray": "Grå andreskross",
  "block.minecraft.banner.cross.green": "Grøn andreskross",
  "block.minecraft.banner.cross.light_blue": "Ljosblå andreskross",
  "block.minecraft.banner.cross.light_gray": "Ljosgrå andreskross",
  "block.minecraft.banner.cross.lime": "Ljosgrøn andreskross",
  "block.minecraft.banner.cross.magenta": "Ljosblåraud andreskross",
  "block.minecraft.banner.cross.orange": "Brandgul andreskross",
  "block.minecraft.banner.cross.pink": "Ljosraud andreskross",
  "block.minecraft.banner.cross.purple": "Blåraud andreskross",
  "block.minecraft.banner.cross.red": "Raud andreskross",
  "block.minecraft.banner.cross.white": "Kvit andreskross",
  "block.minecraft.banner.cross.yellow": "Gul andreskross",
  "block.minecraft.banner.curly_border.black": "Svart bord med taggar",
  "block.minecraft.banner.curly_border.blue": "Blått bord med taggar",
  "block.minecraft.banner.curly_border.brown": "Brunt bord med taggar",
  "block.minecraft.banner.curly_border.cyan": "Blågrønt bord med taggar",
  "block.minecraft.banner.curly_border.gray": "Grått bord med taggar",
  "block.minecraft.banner.curly_border.green": "Grønt bord med taggar",
  "block.minecraft.banner.curly_border.light_blue": "Ljosblått bord med taggar",
  "block.minecraft.banner.curly_border.light_gray": "Ljosgrått bord med taggar",
  "block.minecraft.banner.curly_border.lime": "Ljosgrønt bord med taggar",
  "block.minecraft.banner.curly_border.magenta": "Ljosblåraudt bord med taggar",
  "block.minecraft.banner.curly_border.orange": "Brandgult bord med taggar",
  "block.minecraft.banner.curly_border.pink": "Ljosraudt bord med taggar",
  "block.minecraft.banner.curly_border.purple": "Blåraudt bord med taggar",
  "block.minecraft.banner.curly_border.red": "Raudt bord med taggar",
  "block.minecraft.banner.curly_border.white": "Kvitt bord med taggar",
  "block.minecraft.banner.curly_border.yellow": "Gult bord med taggar",
  "block.minecraft.banner.diagonal_left.black": "Svòrt sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.blue": "Blå sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.brown": "Brun sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.cyan": "Blågrøn sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.gray": "Grå sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.green": "Grøn sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljosblå sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljosgrå sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.lime": "Ljosgrøn sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.magenta": "Ljosblåraud sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.orange": "Brandgul sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.pink": "Ljosraud sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.purple": "Blåraud sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.red": "Raud sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.white": "Kvit sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_left.yellow": "Gul sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_right.black": "Svòrt sneidklovi",
  "block.minecraft.banner.diagonal_right.blue": "Blå sneidklovi",
  "block.minecraft.banner.diagonal_right.brown": "Brun sneidklovi",
  "block.minecraft.banner.diagonal_right.cyan": "Blågrøn sneidklovi",
  "block.minecraft.banner.diagonal_right.gray": "Grå sneidklovi",
  "block.minecraft.banner.diagonal_right.green": "Grøn sneidklovi",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljosblå sneidklovi",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljosgrå sneidklovi",
  "block.minecraft.banner.diagonal_right.lime": "Ljosgrøn sneidklovi",
  "block.minecraft.banner.diagonal_right.magenta": "Ljosblåraud sneidklovi",
  "block.minecraft.banner.diagonal_right.orange": "Brandgul sneidklovi",
  "block.minecraft.banner.diagonal_right.pink": "Ljosraud sneidklovi",
  "block.minecraft.banner.diagonal_right.purple": "Blåraud sneidklovi",
  "block.minecraft.banner.diagonal_right.red": "Raud sneidklovi",
  "block.minecraft.banner.diagonal_right.white": "Kvit sneidklovi",
  "block.minecraft.banner.diagonal_right.yellow": "Gul sneidklovi",
  "block.minecraft.banner.diagonal_up_left.black": "Svòrt umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.cyan": "Blågrøn umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.green": "Grøn umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljosblå umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljosgrå umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.lime": "Ljosgrøn umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.magenta": "Ljosblåraud umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.orange": "Brandgul umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.pink": "Ljosraud umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.purple": "Blåraud umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.red": "Raud umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.white": "Kvit umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gul umvend sneidklovi",
  "block.minecraft.banner.diagonal_up_right.black": "Svòrt umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.cyan": "Blågrøn umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.green": "Grøn umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljosblå umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljosgrå umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.lime": "Ljosgrøn umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ljosblåraud umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.orange": "Brandgul umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.pink": "Ljosraud umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.purple": "Blåraud umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.red": "Raud umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.white": "Kvit umvend sneidklovi frå vinstre",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gul umvend sneidklovi frå vinstre",
  "block.minecraft.banner.flow.black": "Svart straum",
  "block.minecraft.banner.flow.blue": "Blå straum",
  "block.minecraft.banner.flow.brown": "Brun straum",
  "block.minecraft.banner.flow.cyan": "Blågrøn straum",
  "block.minecraft.banner.flow.gray": "Grå straum",
  "block.minecraft.banner.flow.green": "Grøn straum",
  "block.minecraft.banner.flow.light_blue": "Ljosblå straum",
  "block.minecraft.banner.flow.light_gray": "Ljosgrå straum",
  "block.minecraft.banner.flow.lime": "Ljosgrøn straum",
  "block.minecraft.banner.flow.magenta": "Ljosblåraud straum",
  "block.minecraft.banner.flow.orange": "Brandgul straum",
  "block.minecraft.banner.flow.pink": "Ljosraud straum",
  "block.minecraft.banner.flow.purple": "Blåraud straum",
  "block.minecraft.banner.flow.red": "Raud straum",
  "block.minecraft.banner.flow.white": "Kvit straum",
  "block.minecraft.banner.flow.yellow": "Gul straum",
  "block.minecraft.banner.flower.black": "Svart blom",
  "block.minecraft.banner.flower.blue": "Blå blom",
  "block.minecraft.banner.flower.brown": "Brun blom",
  "block.minecraft.banner.flower.cyan": "Blågrøn blom",
  "block.minecraft.banner.flower.gray": "Grå blom",
  "block.minecraft.banner.flower.green": "Grøn blom",
  "block.minecraft.banner.flower.light_blue": "Ljosblå blom",
  "block.minecraft.banner.flower.light_gray": "Ljosgrå blom",
  "block.minecraft.banner.flower.lime": "Ljosgrøn blom",
  "block.minecraft.banner.flower.magenta": "Ljosblåraud blom",
  "block.minecraft.banner.flower.orange": "Brandgul blom",
  "block.minecraft.banner.flower.pink": "Ljosraud blom",
  "block.minecraft.banner.flower.purple": "Blåraud blom",
  "block.minecraft.banner.flower.red": "Raud blom",
  "block.minecraft.banner.flower.white": "Kvit blom",
  "block.minecraft.banner.flower.yellow": "Gul blom",
  "block.minecraft.banner.globe.black": "Svart klote",
  "block.minecraft.banner.globe.blue": "Blå klote",
  "block.minecraft.banner.globe.brown": "Brun klote",
  "block.minecraft.banner.globe.cyan": "Blågrøn klote",
  "block.minecraft.banner.globe.gray": "Grå klote",
  "block.minecraft.banner.globe.green": "Grøn klote",
  "block.minecraft.banner.globe.light_blue": "Ljosblå klote",
  "block.minecraft.banner.globe.light_gray": "Ljosgrå klote",
  "block.minecraft.banner.globe.lime": "Ljosgrøn klote",
  "block.minecraft.banner.globe.magenta": "Ljosblåraud klote",
  "block.minecraft.banner.globe.orange": "Brandgul klote",
  "block.minecraft.banner.globe.pink": "Ljosraud klote",
  "block.minecraft.banner.globe.purple": "Blåraud klote",
  "block.minecraft.banner.globe.red": "Raud klote",
  "block.minecraft.banner.globe.white": "Kvit klote",
  "block.minecraft.banner.globe.yellow": "Gul klote",
  "block.minecraft.banner.gradient.black": "Svart yvergang",
  "block.minecraft.banner.gradient.blue": "Blå yvergang",
  "block.minecraft.banner.gradient.brown": "Brun yvergang",
  "block.minecraft.banner.gradient.cyan": "Blågrøn yvergang",
  "block.minecraft.banner.gradient.gray": "Grå yvergang",
  "block.minecraft.banner.gradient.green": "Grøn yvergang",
  "block.minecraft.banner.gradient.light_blue": "Ljosblå yvergang",
  "block.minecraft.banner.gradient.light_gray": "Ljosgrå yvergang",
  "block.minecraft.banner.gradient.lime": "Ljosgrøn yvergang",
  "block.minecraft.banner.gradient.magenta": "Ljosblåraud yvergang",
  "block.minecraft.banner.gradient.orange": "Brandgul yvergang",
  "block.minecraft.banner.gradient.pink": "Ljosraud yvergang",
  "block.minecraft.banner.gradient.purple": "Blåraud yvergang",
  "block.minecraft.banner.gradient.red": "Raud yvergang",
  "block.minecraft.banner.gradient.white": "Kvit yvergang",
  "block.minecraft.banner.gradient.yellow": "Gul yvergang",
  "block.minecraft.banner.gradient_up.black": "Svart yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.blue": "Blå yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.brown": "Brun yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.cyan": "Blågrøn yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.gray": "Grå yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.green": "Grøn yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.light_blue": "Ljosblå yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.light_gray": "Ljosgrå yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.lime": "Ljosgrøn yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.magenta": "Ljosblåraud yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.orange": "Brandgul yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.pink": "Ljosraud yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.purple": "Blåraud yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.red": "Raud yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.white": "Kvit yvergang frå skjeldfot",
  "block.minecraft.banner.gradient_up.yellow": "Gul yvergang frå skjeldfot",
  "block.minecraft.banner.guster.black": "Svart flagar",
  "block.minecraft.banner.guster.blue": "Blå flagar",
  "block.minecraft.banner.guster.brown": "Brun flagar",
  "block.minecraft.banner.guster.cyan": "Blågrøn flagar",
  "block.minecraft.banner.guster.gray": "Grå flagar",
  "block.minecraft.banner.guster.green": "Grøn flagar",
  "block.minecraft.banner.guster.light_blue": "Ljosblå flagar",
  "block.minecraft.banner.guster.light_gray": "Ljosgrå flagar",
  "block.minecraft.banner.guster.lime": "Ljosgrøn flagar",
  "block.minecraft.banner.guster.magenta": "Ljosblåraud flagar",
  "block.minecraft.banner.guster.orange": "Brandgul flagar",
  "block.minecraft.banner.guster.pink": "Ljosraud flagar",
  "block.minecraft.banner.guster.purple": "Blåraud flagar",
  "block.minecraft.banner.guster.red": "Raud flagar",
  "block.minecraft.banner.guster.white": "Kvit flagar",
  "block.minecraft.banner.guster.yellow": "Gul flagar",
  "block.minecraft.banner.half_horizontal.black": "Svòrt tverklovi",
  "block.minecraft.banner.half_horizontal.blue": "Blå tverklovi",
  "block.minecraft.banner.half_horizontal.brown": "Brun tverklovi",
  "block.minecraft.banner.half_horizontal.cyan": "Blågrøn tverklovi",
  "block.minecraft.banner.half_horizontal.gray": "Grå tverklovi",
  "block.minecraft.banner.half_horizontal.green": "Grøn tverklovi",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljosblå tverklovi",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljosgrå tverklovi",
  "block.minecraft.banner.half_horizontal.lime": "Ljosgrøn tverklovi",
  "block.minecraft.banner.half_horizontal.magenta": "Ljosblåraud tverklovi",
  "block.minecraft.banner.half_horizontal.orange": "Brandgul tverklovi",
  "block.minecraft.banner.half_horizontal.pink": "Ljosraud tverklovi",
  "block.minecraft.banner.half_horizontal.purple": "Blåraud tverklovi",
  "block.minecraft.banner.half_horizontal.red": "Raud tverklovi",
  "block.minecraft.banner.half_horizontal.white": "Kvit tverklovi",
  "block.minecraft.banner.half_horizontal.yellow": "Gul tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svòrt umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Blågrøn umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grøn umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljosblå umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljosgrå umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Ljosgrøn umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Blåraud umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Brandgul umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ljosraud umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Blåraud umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.red": "Raud umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.white": "Kvit umvend tverklovi",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul umvend tverklovi",
  "block.minecraft.banner.half_vertical.black": "Svòrt klovi",
  "block.minecraft.banner.half_vertical.blue": "Blå klovi",
  "block.minecraft.banner.half_vertical.brown": "Brun klovi",
  "block.minecraft.banner.half_vertical.cyan": "Blågrøn klovi",
  "block.minecraft.banner.half_vertical.gray": "Grå klovi",
  "block.minecraft.banner.half_vertical.green": "Grøn klovi",
  "block.minecraft.banner.half_vertical.light_blue": "Ljosblå klovi",
  "block.minecraft.banner.half_vertical.light_gray": "Ljosgrå klovi",
  "block.minecraft.banner.half_vertical.lime": "Ljosgrøn klovi",
  "block.minecraft.banner.half_vertical.magenta": "Ljosblåraud klovi",
  "block.minecraft.banner.half_vertical.orange": "Brandgul klovi",
  "block.minecraft.banner.half_vertical.pink": "Ljosraud klovi",
  "block.minecraft.banner.half_vertical.purple": "Blåraud klovi",
  "block.minecraft.banner.half_vertical.red": "Raud klovi",
  "block.minecraft.banner.half_vertical.white": "Kvit klovi",
  "block.minecraft.banner.half_vertical.yellow": "Gul klovi",
  "block.minecraft.banner.half_vertical_right.black": "Svòrt umvend klovi",
  "block.minecraft.banner.half_vertical_right.blue": "Blå umvend klovi",
  "block.minecraft.banner.half_vertical_right.brown": "Brun umvend klovi",
  "block.minecraft.banner.half_vertical_right.cyan": "Blågrøn umvend klovi",
  "block.minecraft.banner.half_vertical_right.gray": "Grå umvend klovi",
  "block.minecraft.banner.half_vertical_right.green": "Grøn umvend klovi",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljosblå umvend klovi",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljosgrå umvend klovi",
  "block.minecraft.banner.half_vertical_right.lime": "Ljosgrøn umvend klovi",
  "block.minecraft.banner.half_vertical_right.magenta": "Ljosblåraud umvend klovi",
  "block.minecraft.banner.half_vertical_right.orange": "Brandgul umvend klovi",
  "block.minecraft.banner.half_vertical_right.pink": "Ljosraud umvend klovi",
  "block.minecraft.banner.half_vertical_right.purple": "Blåraud umvend klovi",
  "block.minecraft.banner.half_vertical_right.red": "Raud umvend klovi",
  "block.minecraft.banner.half_vertical_right.white": "Kvit umvend klovi",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul umvend klovi",
  "block.minecraft.banner.mojang.black": "Svart ting",
  "block.minecraft.banner.mojang.blue": "Blå ting",
  "block.minecraft.banner.mojang.brown": "Brun ting",
  "block.minecraft.banner.mojang.cyan": "Blågrøn ting",
  "block.minecraft.banner.mojang.gray": "Grå ting",
  "block.minecraft.banner.mojang.green": "Grøn ting",
  "block.minecraft.banner.mojang.light_blue": "Ljosblå ting",
  "block.minecraft.banner.mojang.light_gray": "Ljosgrå ting",
  "block.minecraft.banner.mojang.lime": "Ljosgrøn ting",
  "block.minecraft.banner.mojang.magenta": "Ljosblåraud ting",
  "block.minecraft.banner.mojang.orange": "Brandgul ting",
  "block.minecraft.banner.mojang.pink": "Ljosraud ting",
  "block.minecraft.banner.mojang.purple": "Blåraud ting",
  "block.minecraft.banner.mojang.red": "Raud ting",
  "block.minecraft.banner.mojang.white": "Kvit ting",
  "block.minecraft.banner.mojang.yellow": "Gul ting",
  "block.minecraft.banner.piglin.black": "Svart tryne",
  "block.minecraft.banner.piglin.blue": "Blått tryne",
  "block.minecraft.banner.piglin.brown": "Brunt tryne",
  "block.minecraft.banner.piglin.cyan": "Blågrønt tryne",
  "block.minecraft.banner.piglin.gray": "Grått tryne",
  "block.minecraft.banner.piglin.green": "Grønt tryne",
  "block.minecraft.banner.piglin.light_blue": "Ljosblått tryne",
  "block.minecraft.banner.piglin.light_gray": "Ljosgrått tryne",
  "block.minecraft.banner.piglin.lime": "Ljosgrønt tryne",
  "block.minecraft.banner.piglin.magenta": "Ljoslilla tryne",
  "block.minecraft.banner.piglin.orange": "Brandgult tryne",
  "block.minecraft.banner.piglin.pink": "Ljosraudt tryne",
  "block.minecraft.banner.piglin.purple": "Blåraudt tryne",
  "block.minecraft.banner.piglin.red": "Raudt tryne",
  "block.minecraft.banner.piglin.white": "Kvitt tryne",
  "block.minecraft.banner.piglin.yellow": "Gult tryne",
  "block.minecraft.banner.rhombus.black": "Svart rombe",
  "block.minecraft.banner.rhombus.blue": "Blå rombe",
  "block.minecraft.banner.rhombus.brown": "Brun rombe",
  "block.minecraft.banner.rhombus.cyan": "Blågrøn rombe",
  "block.minecraft.banner.rhombus.gray": "Grå rombe",
  "block.minecraft.banner.rhombus.green": "Grøn rombe",
  "block.minecraft.banner.rhombus.light_blue": "Ljosblå rombe",
  "block.minecraft.banner.rhombus.light_gray": "Ljosgrå rombe",
  "block.minecraft.banner.rhombus.lime": "Ljosgrøn rombe",
  "block.minecraft.banner.rhombus.magenta": "Ljosblåraud rombe",
  "block.minecraft.banner.rhombus.orange": "Brandgul rombe",
  "block.minecraft.banner.rhombus.pink": "Ljosraud rombe",
  "block.minecraft.banner.rhombus.purple": "Blåraud rombe",
  "block.minecraft.banner.rhombus.red": "Raud rombe",
  "block.minecraft.banner.rhombus.white": "Kvit rombe",
  "block.minecraft.banner.rhombus.yellow": "Gul rombe",
  "block.minecraft.banner.skull.black": "Svart skalle",
  "block.minecraft.banner.skull.blue": "Blå skalle",
  "block.minecraft.banner.skull.brown": "Brun skalle",
  "block.minecraft.banner.skull.cyan": "Blågrøn skalle",
  "block.minecraft.banner.skull.gray": "Grå skalle",
  "block.minecraft.banner.skull.green": "Grøn skalle",
  "block.minecraft.banner.skull.light_blue": "Ljosblå skalle",
  "block.minecraft.banner.skull.light_gray": "Ljosgrå skalle",
  "block.minecraft.banner.skull.lime": "Ljosgrøn skalle",
  "block.minecraft.banner.skull.magenta": "Ljosblåraud skalle",
  "block.minecraft.banner.skull.orange": "Brandgul skalle",
  "block.minecraft.banner.skull.pink": "Ljosraud skalle",
  "block.minecraft.banner.skull.purple": "Blåraud skalle",
  "block.minecraft.banner.skull.red": "Raud skalle",
  "block.minecraft.banner.skull.white": "Kvit skalle",
  "block.minecraft.banner.skull.yellow": "Gul skalle",
  "block.minecraft.banner.small_stripes.black": "Svarte stolpar",
  "block.minecraft.banner.small_stripes.blue": "Blå stolpar",
  "block.minecraft.banner.small_stripes.brown": "Brune stolpar",
  "block.minecraft.banner.small_stripes.cyan": "Blågrøne stolpar",
  "block.minecraft.banner.small_stripes.gray": "Grå stolpar",
  "block.minecraft.banner.small_stripes.green": "Grøne stolpar",
  "block.minecraft.banner.small_stripes.light_blue": "Ljosblå stolpar",
  "block.minecraft.banner.small_stripes.light_gray": "Ljosgrå stolpar",
  "block.minecraft.banner.small_stripes.lime": "Ljosgrøne stolpar",
  "block.minecraft.banner.small_stripes.magenta": "Ljosblåraude stolpar",
  "block.minecraft.banner.small_stripes.orange": "Brandgule stolpar",
  "block.minecraft.banner.small_stripes.pink": "Ljosraude stolpar",
  "block.minecraft.banner.small_stripes.purple": "Blåraude stolpar",
  "block.minecraft.banner.small_stripes.red": "Raude stolpar",
  "block.minecraft.banner.small_stripes.white": "Kvite stolpar",
  "block.minecraft.banner.small_stripes.yellow": "Gule stolpar",
  "block.minecraft.banner.square_bottom_left.black": "Svart høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.blue": "Blå høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.brown": "Brun høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.cyan": "Blågrøn høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.gray": "Grå høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.green": "Grøn høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljosblå høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljosgrå høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.lime": "Ljosgrøn høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.magenta": "Ljosblåraud høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.orange": "Brandgul høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.pink": "Ljosraud høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.purple": "Blåraud høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.red": "Raud høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.white": "Kvit høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_left.yellow": "Gul høgreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.black": "Svart vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.blue": "Blå vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.brown": "Brun vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.cyan": "Blågrøn vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.gray": "Grå vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.green": "Grøn vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljosblå vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljosgrå vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.lime": "Ljosgrøn vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.magenta": "Ljosblåraud vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.orange": "Brandgul vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.pink": "Ljosraud vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.purple": "Blåraud vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.red": "Raud vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.white": "Kvit vinstreteig i skjeldfot",
  "block.minecraft.banner.square_bottom_right.yellow": "Gul vinstreteig i skjeldfot",
  "block.minecraft.banner.square_top_left.black": "Svart høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.blue": "Blå høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.brown": "Brun høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.cyan": "Blågrøn høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.gray": "Grå høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.green": "Grøn høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.light_blue": "Ljosblå høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.light_gray": "Ljosgrå høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.lime": "Ljosgrøn høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.magenta": "Ljosblåraud høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.orange": "Brandgul høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.pink": "Ljosraud høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.purple": "Blåraud høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.red": "Raud høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.white": "Kvit høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_left.yellow": "Gul høgreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.black": "Svart vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.blue": "Blå vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.brown": "Brun vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.cyan": "Blågrøn vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.gray": "Grå vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.green": "Grøn vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.light_blue": "Ljosblå vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.light_gray": "Ljosgrå vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.lime": "Ljosgrøn vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.magenta": "Ljosblåraud vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.orange": "Brandgul vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.pink": "Ljosraud vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.purple": "Blåraud vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.red": "Raud vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.white": "Kvit vinstreteig i skjeldhovud",
  "block.minecraft.banner.square_top_right.yellow": "Gul vinstreteig i skjeldhovud",
  "block.minecraft.banner.straight_cross.black": "Svart kross",
  "block.minecraft.banner.straight_cross.blue": "Blå kross",
  "block.minecraft.banner.straight_cross.brown": "Brun kross",
  "block.minecraft.banner.straight_cross.cyan": "Blågrøn kross",
  "block.minecraft.banner.straight_cross.gray": "Grå kross",
  "block.minecraft.banner.straight_cross.green": "Grøn kross",
  "block.minecraft.banner.straight_cross.light_blue": "Ljosblå kross",
  "block.minecraft.banner.straight_cross.light_gray": "Ljosgrå kross",
  "block.minecraft.banner.straight_cross.lime": "Ljosgrøn kross",
  "block.minecraft.banner.straight_cross.magenta": "Ljosblåraud kross",
  "block.minecraft.banner.straight_cross.orange": "Brandgul kross",
  "block.minecraft.banner.straight_cross.pink": "Ljosraud kross",
  "block.minecraft.banner.straight_cross.purple": "Blåraud kross",
  "block.minecraft.banner.straight_cross.red": "Raud kross",
  "block.minecraft.banner.straight_cross.white": "Kvit kross",
  "block.minecraft.banner.straight_cross.yellow": "Gul kross",
  "block.minecraft.banner.stripe_bottom.black": "Svart skjeldfot",
  "block.minecraft.banner.stripe_bottom.blue": "Blå skjeldfot",
  "block.minecraft.banner.stripe_bottom.brown": "Brun skjeldfot",
  "block.minecraft.banner.stripe_bottom.cyan": "Blågrøn skjeldfot",
  "block.minecraft.banner.stripe_bottom.gray": "Grå skjeldfot",
  "block.minecraft.banner.stripe_bottom.green": "Grøn skjeldfot",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljosblå skjeldfot",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljosgrå skjeldfot",
  "block.minecraft.banner.stripe_bottom.lime": "Ljosgrøn skjeldfot",
  "block.minecraft.banner.stripe_bottom.magenta": "Ljosblåraud skjeldfot",
  "block.minecraft.banner.stripe_bottom.orange": "Brandgul skjeldfot",
  "block.minecraft.banner.stripe_bottom.pink": "Ljosraud skjeldfot",
  "block.minecraft.banner.stripe_bottom.purple": "Blåraud skjeldfot",
  "block.minecraft.banner.stripe_bottom.red": "Raud skjeldfot",
  "block.minecraft.banner.stripe_bottom.white": "Kvit skjeldfot",
  "block.minecraft.banner.stripe_bottom.yellow": "Gul skjeldfot",
  "block.minecraft.banner.stripe_center.black": "Svart stolpe",
  "block.minecraft.banner.stripe_center.blue": "Blå stolpe",
  "block.minecraft.banner.stripe_center.brown": "Brun stolpe",
  "block.minecraft.banner.stripe_center.cyan": "Blågrøn stolpe",
  "block.minecraft.banner.stripe_center.gray": "Grå stolpe",
  "block.minecraft.banner.stripe_center.green": "Grøn stolpe",
  "block.minecraft.banner.stripe_center.light_blue": "Ljosblå stolpe",
  "block.minecraft.banner.stripe_center.light_gray": "Ljosgrå stolpe",
  "block.minecraft.banner.stripe_center.lime": "Ljosgrøn stolpe",
  "block.minecraft.banner.stripe_center.magenta": "Ljosblåraud stolpe",
  "block.minecraft.banner.stripe_center.orange": "Brandgul stolpe",
  "block.minecraft.banner.stripe_center.pink": "Ljosraud stolpe",
  "block.minecraft.banner.stripe_center.purple": "Blåraud stolpe",
  "block.minecraft.banner.stripe_center.red": "Raud stolpe",
  "block.minecraft.banner.stripe_center.white": "Kvit stolpe",
  "block.minecraft.banner.stripe_center.yellow": "Gul stolpe",
  "block.minecraft.banner.stripe_downleft.black": "Svart vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.blue": "Blå vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.brown": "Brun vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.cyan": "Blågrøn vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.gray": "Grå vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.green": "Grøn vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljosblå vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljosgrå vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.lime": "Ljosgrøn vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.magenta": "Ljosblåraud vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.orange": "Brandgul vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.pink": "Ljosraud vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.purple": "Blåraud vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.red": "Raud vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.white": "Kvit vinstretverbjelke",
  "block.minecraft.banner.stripe_downleft.yellow": "Gul vinstretverbjelke",
  "block.minecraft.banner.stripe_downright.black": "Svart tverbjelke",
  "block.minecraft.banner.stripe_downright.blue": "Blå tverbjelke",
  "block.minecraft.banner.stripe_downright.brown": "Brun tverbjelke",
  "block.minecraft.banner.stripe_downright.cyan": "Blågrøn tverbjelke",
  "block.minecraft.banner.stripe_downright.gray": "Grå tverbjelke",
  "block.minecraft.banner.stripe_downright.green": "Grøn tverbjelke",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljosblå tverbjelke",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljosgrå tverbjelke",
  "block.minecraft.banner.stripe_downright.lime": "Ljosgrøn tverbjelke",
  "block.minecraft.banner.stripe_downright.magenta": "Ljosblåraud tverbjelke",
  "block.minecraft.banner.stripe_downright.orange": "Brandgul tverbjelke",
  "block.minecraft.banner.stripe_downright.pink": "Ljosraud tverbjelke",
  "block.minecraft.banner.stripe_downright.purple": "Blåraud tverbjelke",
  "block.minecraft.banner.stripe_downright.red": "Raud tverbjelke",
  "block.minecraft.banner.stripe_downright.white": "Kvit tverbjelke",
  "block.minecraft.banner.stripe_downright.yellow": "Gul tverbjelke",
  "block.minecraft.banner.stripe_left.black": "Svart høgrestolpe",
  "block.minecraft.banner.stripe_left.blue": "Blå høgrestolpe",
  "block.minecraft.banner.stripe_left.brown": "Brun høgrestolpe",
  "block.minecraft.banner.stripe_left.cyan": "Blågrøn høgrestolpe",
  "block.minecraft.banner.stripe_left.gray": "Grå høgrestolpe",
  "block.minecraft.banner.stripe_left.green": "Grøn høgrestolpe",
  "block.minecraft.banner.stripe_left.light_blue": "Ljosblå høgrestolpe",
  "block.minecraft.banner.stripe_left.light_gray": "Ljosgrå høgrestolpe",
  "block.minecraft.banner.stripe_left.lime": "Ljosgrøn høgrestolpe",
  "block.minecraft.banner.stripe_left.magenta": "Ljosblåraud høgrestolpe",
  "block.minecraft.banner.stripe_left.orange": "Brandgul høgrestolpe",
  "block.minecraft.banner.stripe_left.pink": "Ljosraud høgrestolpe",
  "block.minecraft.banner.stripe_left.purple": "Blåraud høgrestolpe",
  "block.minecraft.banner.stripe_left.red": "Raud høgrestolpe",
  "block.minecraft.banner.stripe_left.white": "Kvit høgrestolpe",
  "block.minecraft.banner.stripe_left.yellow": "Gul høgrestolpe",
  "block.minecraft.banner.stripe_middle.black": "Svart bjelke",
  "block.minecraft.banner.stripe_middle.blue": "Blå bjelke",
  "block.minecraft.banner.stripe_middle.brown": "Brun bjelke",
  "block.minecraft.banner.stripe_middle.cyan": "Blågrøn bjelke",
  "block.minecraft.banner.stripe_middle.gray": "Grå bjelke",
  "block.minecraft.banner.stripe_middle.green": "Grøn bjelke",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljosblå bjelke",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljosgrå bjelke",
  "block.minecraft.banner.stripe_middle.lime": "Ljosgrøn bjelke",
  "block.minecraft.banner.stripe_middle.magenta": "Ljosblåraud bjelke",
  "block.minecraft.banner.stripe_middle.orange": "Brandgul bjelke",
  "block.minecraft.banner.stripe_middle.pink": "Ljosraud bjelke",
  "block.minecraft.banner.stripe_middle.purple": "Blåraud bjelke",
  "block.minecraft.banner.stripe_middle.red": "Raud bjelke",
  "block.minecraft.banner.stripe_middle.white": "Kvit bjelke",
  "block.minecraft.banner.stripe_middle.yellow": "Gul bjelke",
  "block.minecraft.banner.stripe_right.black": "Svart vinstrestolpe",
  "block.minecraft.banner.stripe_right.blue": "Blå vinstrestolpe",
  "block.minecraft.banner.stripe_right.brown": "Brun vinstrestolpe",
  "block.minecraft.banner.stripe_right.cyan": "Blågrøn vinstrestolpe",
  "block.minecraft.banner.stripe_right.gray": "Grå vinstrestolpe",
  "block.minecraft.banner.stripe_right.green": "Grøn vinstrestolpe",
  "block.minecraft.banner.stripe_right.light_blue": "Ljosblå vinstrestolpe",
  "block.minecraft.banner.stripe_right.light_gray": "Ljosgrå vinstrestolpe",
  "block.minecraft.banner.stripe_right.lime": "Ljosgrøn vinstrestolpe",
  "block.minecraft.banner.stripe_right.magenta": "Ljosblåraud vinstrestolpe",
  "block.minecraft.banner.stripe_right.orange": "Brandgul vinstrestolpe",
  "block.minecraft.banner.stripe_right.pink": "Ljosraud vinstrestolpe",
  "block.minecraft.banner.stripe_right.purple": "Blåraud vinstrestolpe",
  "block.minecraft.banner.stripe_right.red": "Raud vinstrestolpe",
  "block.minecraft.banner.stripe_right.white": "Kvit vinstrestolpe",
  "block.minecraft.banner.stripe_right.yellow": "Gul vinstrestolpe",
  "block.minecraft.banner.stripe_top.black": "Svart skjeldhovud",
  "block.minecraft.banner.stripe_top.blue": "Blått skjeldhovud",
  "block.minecraft.banner.stripe_top.brown": "Brunt skjeldhovud",
  "block.minecraft.banner.stripe_top.cyan": "Blågrønt skjeldhovud",
  "block.minecraft.banner.stripe_top.gray": "Grått skjeldhovud",
  "block.minecraft.banner.stripe_top.green": "Grønt skjeldhovud",
  "block.minecraft.banner.stripe_top.light_blue": "Ljosblått skjeldhovud",
  "block.minecraft.banner.stripe_top.light_gray": "Ljosgrått skjeldhovud",
  "block.minecraft.banner.stripe_top.lime": "Ljosgrønt skjeldhovud",
  "block.minecraft.banner.stripe_top.magenta": "Ljosblåraudt skjeldhovud",
  "block.minecraft.banner.stripe_top.orange": "Brandgult skjeldhovud",
  "block.minecraft.banner.stripe_top.pink": "Ljosraud skjeldhovud",
  "block.minecraft.banner.stripe_top.purple": "Blåraudt skjeldhovud",
  "block.minecraft.banner.stripe_top.red": "Raudt skjeldhovud",
  "block.minecraft.banner.stripe_top.white": "Kvitt skjeldhovud",
  "block.minecraft.banner.stripe_top.yellow": "Gult skjeldhovud",
  "block.minecraft.banner.triangle_bottom.black": "Svart sparre",
  "block.minecraft.banner.triangle_bottom.blue": "Blå sparre",
  "block.minecraft.banner.triangle_bottom.brown": "Brun sparre",
  "block.minecraft.banner.triangle_bottom.cyan": "Blågrøn sparre",
  "block.minecraft.banner.triangle_bottom.gray": "Grå sparre",
  "block.minecraft.banner.triangle_bottom.green": "Grøn sparre",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljosblå sparre",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljosgrå sparre",
  "block.minecraft.banner.triangle_bottom.lime": "Ljosgrøn sparre",
  "block.minecraft.banner.triangle_bottom.magenta": "Ljosblåraud sparre",
  "block.minecraft.banner.triangle_bottom.orange": "Brandgul sparre",
  "block.minecraft.banner.triangle_bottom.pink": "Ljosraud sparre",
  "block.minecraft.banner.triangle_bottom.purple": "Blåraud sparre",
  "block.minecraft.banner.triangle_bottom.red": "Raud sparre",
  "block.minecraft.banner.triangle_bottom.white": "Kvit sparre",
  "block.minecraft.banner.triangle_bottom.yellow": "Gul sparre",
  "block.minecraft.banner.triangle_top.black": "Svart umvend sparre",
  "block.minecraft.banner.triangle_top.blue": "Blå umvend sparre",
  "block.minecraft.banner.triangle_top.brown": "Brun umvend sparre",
  "block.minecraft.banner.triangle_top.cyan": "Blågrøn umvend sparre",
  "block.minecraft.banner.triangle_top.gray": "Grå umvend sparre",
  "block.minecraft.banner.triangle_top.green": "Grøn umvend sparre",
  "block.minecraft.banner.triangle_top.light_blue": "Ljosblå umvend sparre",
  "block.minecraft.banner.triangle_top.light_gray": "Ljosgrå umvend sparre",
  "block.minecraft.banner.triangle_top.lime": "Ljosgrøn umvend sparre",
  "block.minecraft.banner.triangle_top.magenta": "Ljosblåraud umvend sparre",
  "block.minecraft.banner.triangle_top.orange": "Brandgul umvend sparre",
  "block.minecraft.banner.triangle_top.pink": "Ljosraud umvend sparre",
  "block.minecraft.banner.triangle_top.purple": "Blåraud umvend sparre",
  "block.minecraft.banner.triangle_top.red": "Raud umvend sparre",
  "block.minecraft.banner.triangle_top.white": "Kvit umvend sparre",
  "block.minecraft.banner.triangle_top.yellow": "Gul umvend sparre",
  "block.minecraft.banner.triangles_bottom.black": "Svarte taggar nedre",
  "block.minecraft.banner.triangles_bottom.blue": "Blå taggar nedre",
  "block.minecraft.banner.triangles_bottom.brown": "Brune taggar nedre",
  "block.minecraft.banner.triangles_bottom.cyan": "Blågrøne taggar nedre",
  "block.minecraft.banner.triangles_bottom.gray": "Grå taggar nedre",
  "block.minecraft.banner.triangles_bottom.green": "Grøne taggar nedre",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljosblå taggar nedre",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljosgrå taggar nedre",
  "block.minecraft.banner.triangles_bottom.lime": "Ljosgrøne taggar nedre",
  "block.minecraft.banner.triangles_bottom.magenta": "Ljosblåraude taggar nedre",
  "block.minecraft.banner.triangles_bottom.orange": "Brandgule taggar nedre",
  "block.minecraft.banner.triangles_bottom.pink": "Ljosraude taggar nedre",
  "block.minecraft.banner.triangles_bottom.purple": "Blåraude taggar nedre",
  "block.minecraft.banner.triangles_bottom.red": "Raude taggar nedre",
  "block.minecraft.banner.triangles_bottom.white": "Kvite taggar nedre",
  "block.minecraft.banner.triangles_bottom.yellow": "Gule taggar nedre",
  "block.minecraft.banner.triangles_top.black": "Svarte taggar uppe",
  "block.minecraft.banner.triangles_top.blue": "Blå taggar uppe",
  "block.minecraft.banner.triangles_top.brown": "Brune taggar uppe",
  "block.minecraft.banner.triangles_top.cyan": "Blågrøne taggar uppe",
  "block.minecraft.banner.triangles_top.gray": "Grå taggar uppe",
  "block.minecraft.banner.triangles_top.green": "Grøne taggar uppe",
  "block.minecraft.banner.triangles_top.light_blue": "Ljosblå taggar uppe",
  "block.minecraft.banner.triangles_top.light_gray": "Ljosgrå taggar uppe",
  "block.minecraft.banner.triangles_top.lime": "Ljosgrøne taggar uppe",
  "block.minecraft.banner.triangles_top.magenta": "Ljosblåraude taggar uppe",
  "block.minecraft.banner.triangles_top.orange": "Brandgule taggar uppe",
  "block.minecraft.banner.triangles_top.pink": "Ljosraude taggar uppe",
  "block.minecraft.banner.triangles_top.purple": "Blåraude taggar uppe",
  "block.minecraft.banner.triangles_top.red": "Raude taggar uppe",
  "block.minecraft.banner.triangles_top.white": "Kvite taggar uppe",
  "block.minecraft.banner.triangles_top.yellow": "Gule taggar uppe",
  "block.minecraft.barrel": "Tunna",
  "block.minecraft.barrier": "Bægje",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Vìte",
  "block.minecraft.beacon.primary": "Hovudkraft",
  "block.minecraft.beacon.secondary": "Attåtkraft",
  "block.minecraft.bed.no_sleep": "Du kann berre sova um notti elder i toreveder",
  "block.minecraft.bed.not_safe": "Du kann ’kje sova no; skræmsl ero i nærleiken",
  "block.minecraft.bed.obstructed": "Denne sengi er hindrad",
  "block.minecraft.bed.occupied": "Denne sengi er uppteki",
  "block.minecraft.bed.too_far_away": "Du kann ’kje sova no; sengi er for langt undan",
  "block.minecraft.bedrock": "Grunnfjell",
  "block.minecraft.bee_nest": "Biebol",
  "block.minecraft.beehive": "Biehus",
  "block.minecraft.beetroots": "Raudbetor",
  "block.minecraft.bell": "Bjølla",
  "block.minecraft.big_dripleaf": "Stort droplauv",
  "block.minecraft.big_dripleaf_stem": "Stylk av stort droplauv",
  "block.minecraft.birch_button": "Bjørkarknapp",
  "block.minecraft.birch_door": "Bjørkardỳr",
  "block.minecraft.birch_fence": "Bjørkargard",
  "block.minecraft.birch_fence_gate": "Bjørkargrind",
  "block.minecraft.birch_hanging_sign": "Hangande bjørkarskilt",
  "block.minecraft.birch_leaves": "Bjørkarlauv",
  "block.minecraft.birch_log": "Bjørkarstomn",
  "block.minecraft.birch_planks": "Bjørkarbord",
  "block.minecraft.birch_pressure_plate": "Bjørkar-tyngdarfjøl",
  "block.minecraft.birch_sapling": "Bjørkarrenning",
  "block.minecraft.birch_shelf": "Bjørkarhylla",
  "block.minecraft.birch_sign": "Bjørkarskilt",
  "block.minecraft.birch_slab": "Bjørkarhella",
  "block.minecraft.birch_stairs": "Bjørkartropp",
  "block.minecraft.birch_trapdoor": "Bjørkarlem",
  "block.minecraft.birch_wall_hanging_sign": "Hangande bjørkarskilt på vegg",
  "block.minecraft.birch_wall_sign": "Bjørkarveggskilt",
  "block.minecraft.birch_wood": "Bjørkarvìd",
  "block.minecraft.black_banner": "Svòrt fana",
  "block.minecraft.black_bed": "Svòrt seng",
  "block.minecraft.black_candle": "Svart vaksljos",
  "block.minecraft.black_candle_cake": "Kaka med svart vaksljos",
  "block.minecraft.black_carpet": "Svòrt rya",
  "block.minecraft.black_concrete": "Svart støypestein",
  "block.minecraft.black_concrete_powder": "Svòrt støypesteinsdumba",
  "block.minecraft.black_glazed_terracotta": "Svòrt glasad terrakotta",
  "block.minecraft.black_shulker_box": "Svart shulkerhus",
  "block.minecraft.black_stained_glass": "Svartlìtat glas",
  "block.minecraft.black_stained_glass_pane": "Svartlìtad glasruta",
  "block.minecraft.black_terracotta": "Svòrt terrakotta",
  "block.minecraft.black_wool": "Svòrt ull",
  "block.minecraft.blackstone": "Svartstein",
  "block.minecraft.blackstone_slab": "Svartsteinshella",
  "block.minecraft.blackstone_stairs": "Svartsteinstropp",
  "block.minecraft.blackstone_wall": "Svartsteinsvegg",
  "block.minecraft.blast_furnace": "Malmomn",
  "block.minecraft.blue_banner": "Blå fana",
  "block.minecraft.blue_bed": "Blå seng",
  "block.minecraft.blue_candle": "Blått vaksljos",
  "block.minecraft.blue_candle_cake": "Kaka med blått vaksljos",
  "block.minecraft.blue_carpet": "Blå rya",
  "block.minecraft.blue_concrete": "Blå støypestein",
  "block.minecraft.blue_concrete_powder": "Blå støypesteinsdumba",
  "block.minecraft.blue_glazed_terracotta": "Blå glasa terrakotta",
  "block.minecraft.blue_ice": "Blåis",
  "block.minecraft.blue_orchid": "Blå orkidé",
  "block.minecraft.blue_shulker_box": "Blått shulkerhus",
  "block.minecraft.blue_stained_glass": "Blålìtat glas",
  "block.minecraft.blue_stained_glass_pane": "Blålìtad glasruta",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå ull",
  "block.minecraft.bone_block": "Beinblokk",
  "block.minecraft.bookshelf": "Bokhylla",
  "block.minecraft.brain_coral": "Heilekorall",
  "block.minecraft.brain_coral_block": "Heilekorallblokk",
  "block.minecraft.brain_coral_fan": "Heilekorallveifta",
  "block.minecraft.brain_coral_wall_fan": "Heilekorallveggveifta",
  "block.minecraft.brewing_stand": "Bryggjestod",
  "block.minecraft.brick_slab": "Tiglhella",
  "block.minecraft.brick_stairs": "Tigltropp",
  "block.minecraft.brick_wall": "Tiglvegg",
  "block.minecraft.bricks": "Tigl",
  "block.minecraft.brown_banner": "Brun fana",
  "block.minecraft.brown_bed": "Brun seng",
  "block.minecraft.brown_candle": "Brunt vaksljos",
  "block.minecraft.brown_candle_cake": "Kaka med brunt vaksljos",
  "block.minecraft.brown_carpet": "Brun rya",
  "block.minecraft.brown_concrete": "Brun støypestein",
  "block.minecraft.brown_concrete_powder": "Brun støypesteinsdumba",
  "block.minecraft.brown_glazed_terracotta": "Brun glasad terrakotta",
  "block.minecraft.brown_mushroom": "Brun sopp",
  "block.minecraft.brown_mushroom_block": "Brun soppblokk",
  "block.minecraft.brown_shulker_box": "Brunt shulkerhus",
  "block.minecraft.brown_stained_glass": "Brunlìtat glas",
  "block.minecraft.brown_stained_glass_pane": "Brunlìtad glasruta",
  "block.minecraft.brown_terracotta": "Brun terrakotta",
  "block.minecraft.brown_wool": "Brun ull",
  "block.minecraft.bubble_column": "Bublesula",
  "block.minecraft.bubble_coral": "Bublekorall",
  "block.minecraft.bubble_coral_block": "Bublekorallblokk",
  "block.minecraft.bubble_coral_fan": "Bublekorallveifta",
  "block.minecraft.bubble_coral_wall_fan": "Bublekorallveggveifta",
  "block.minecraft.budding_amethyst": "Knuppande ametyst",
  "block.minecraft.bush": "Runn",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblom",
  "block.minecraft.cake": "Kaka",
  "block.minecraft.calcite": "Kalkspat",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrerad sculkegaumar",
  "block.minecraft.campfire": "Bål",
  "block.minecraft.candle": "Vaksljos",
  "block.minecraft.candle_cake": "Kaka med vaksljos",
  "block.minecraft.carrots": "Gulrøter",
  "block.minecraft.cartography_table": "Kartteiknarbord",
  "block.minecraft.carved_pumpkin": "Utskoret graskjer",
  "block.minecraft.cauldron": "Gryta",
  "block.minecraft.cave_air": "Hòlevind",
  "block.minecraft.cave_vines": "Hangande hòlevokster",
  "block.minecraft.cave_vines_plant": "Hangande hòlevokster",
  "block.minecraft.chain": "Jarnkjedja",
  "block.minecraft.chain_command_block": "Kjedje-styrebòdsblokk",
  "block.minecraft.cherry_button": "Kisseberknapp",
  "block.minecraft.cherry_door": "Kisseberdỳr",
  "block.minecraft.cherry_fence": "Kissebergard",
  "block.minecraft.cherry_fence_gate": "Kissebergrind",
  "block.minecraft.cherry_hanging_sign": "Hangande kisseberskilt",
  "block.minecraft.cherry_leaves": "Kisseberlauv",
  "block.minecraft.cherry_log": "Kisseberstomn",
  "block.minecraft.cherry_planks": "Kisseberbord",
  "block.minecraft.cherry_pressure_plate": "Kisseber-tyngdarfjøl",
  "block.minecraft.cherry_sapling": "Kisseberrenning",
  "block.minecraft.cherry_shelf": "Kisseberhylla",
  "block.minecraft.cherry_sign": "Kisseberskilt",
  "block.minecraft.cherry_slab": "Kisseberhella",
  "block.minecraft.cherry_stairs": "Kissebertropp",
  "block.minecraft.cherry_trapdoor": "Kisseberlem",
  "block.minecraft.cherry_wall_hanging_sign": "Hangande kisseberskilt på vegg",
  "block.minecraft.cherry_wall_sign": "Kisseberveggskilt",
  "block.minecraft.cherry_wood": "Kissebervìd",
  "block.minecraft.chest": "Kista",
  "block.minecraft.chipped_anvil": "Sprokket sted",
  "block.minecraft.chiseled_bookshelf": "Meitlad bokhylla",
  "block.minecraft.chiseled_copper": "Meitlad kopar",
  "block.minecraft.chiseled_deepslate": "Meitlad djupskifer",
  "block.minecraft.chiseled_nether_bricks": "Meitlat nethertigl",
  "block.minecraft.chiseled_polished_blackstone": "Meitlad finslipen svartstein",
  "block.minecraft.chiseled_quartz_block": "Meitlad kattsteinsblokk",
  "block.minecraft.chiseled_red_sandstone": "Meitlad raud sandstein",
  "block.minecraft.chiseled_resin_bricks": "Meitlat kvådetigl",
  "block.minecraft.chiseled_sandstone": "Meitlad sandstein",
  "block.minecraft.chiseled_stone_bricks": "Meitlat steintigl",
  "block.minecraft.chiseled_tuff": "Meitlad tuff",
  "block.minecraft.chiseled_tuff_bricks": "Meitlat tufftigl",
  "block.minecraft.chorus_flower": "Korblom",
  "block.minecraft.chorus_plant": "Korvokster",
  "block.minecraft.clay": "Leir",
  "block.minecraft.closed_eyeblossom": "Attlaten augblom",
  "block.minecraft.coal_block": "Kolblokk",
  "block.minecraft.coal_ore": "Kolår",
  "block.minecraft.coarse_dirt": "Grov mold",
  "block.minecraft.cobbled_deepslate": "Djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_slab": "Hella av djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_stairs": "Tropp av djupskifer-brustein",
  "block.minecraft.cobbled_deepslate_wall": "Vegg av djupskifer-brustein",
  "block.minecraft.cobblestone": "Brustein",
  "block.minecraft.cobblestone_slab": "Brusteinshella",
  "block.minecraft.cobblestone_stairs": "Brusteinstropp",
  "block.minecraft.cobblestone_wall": "Brusteinsvegg",
  "block.minecraft.cobweb": "Kongurvev",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Styrebòdsblokk",
  "block.minecraft.comparator": "Redstone-samanliknar",
  "block.minecraft.composter": "Bòstadbing",
  "block.minecraft.conduit": "Flødar",
  "block.minecraft.copper_bars": "Kopargrind",
  "block.minecraft.copper_block": "Koparblokk",
  "block.minecraft.copper_bulb": "Koparpera",
  "block.minecraft.copper_chain": "Koparkjedja",
  "block.minecraft.copper_chest": "Koparkista",
  "block.minecraft.copper_door": "Kopardỳr",
  "block.minecraft.copper_golem_statue": "Eirgjengelstytta",
  "block.minecraft.copper_grate": "Koparrist",
  "block.minecraft.copper_lantern": "Koparlykt",
  "block.minecraft.copper_ore": "Koparmalm",
  "block.minecraft.copper_torch": "Koparkyndel",
  "block.minecraft.copper_trapdoor": "Koparlem",
  "block.minecraft.copper_wall_torch": "Veggkoparkyndel",
  "block.minecraft.cornflower": "Kornblom",
  "block.minecraft.cracked_deepslate_bricks": "Sprokket djupskifertigl",
  "block.minecraft.cracked_deepslate_tiles": "Sprokkne djupskiferflisar",
  "block.minecraft.cracked_nether_bricks": "Sprokket nethertigl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sprokke finslipe svartsteinstigl",
  "block.minecraft.cracked_stone_bricks": "Sprokke steintigl",
  "block.minecraft.crafter": "Emnar",
  "block.minecraft.crafting_table": "Emnebord",
  "block.minecraft.creaking_heart": "Knerkadal",
  "block.minecraft.creeper_head": "Creeperhovud",
  "block.minecraft.creeper_wall_head": "Creepervegghovud",
  "block.minecraft.crimson_button": "Blodknapp",
  "block.minecraft.crimson_door": "Bloddỳr",
  "block.minecraft.crimson_fence": "Blodgard",
  "block.minecraft.crimson_fence_gate": "Blodgrind",
  "block.minecraft.crimson_fungus": "Blodsopp",
  "block.minecraft.crimson_hanging_sign": "Hangande blodskilt",
  "block.minecraft.crimson_hyphae": "Blodhyfor",
  "block.minecraft.crimson_nylium": "Blodsoppvev",
  "block.minecraft.crimson_planks": "Blodbord",
  "block.minecraft.crimson_pressure_plate": "Blod-tyngdarfjøl",
  "block.minecraft.crimson_roots": "Blodrøter",
  "block.minecraft.crimson_shelf": "Blodhylla",
  "block.minecraft.crimson_sign": "Blodskilt",
  "block.minecraft.crimson_slab": "Blodhella",
  "block.minecraft.crimson_stairs": "Blodtropp",
  "block.minecraft.crimson_stem": "Blodstomn",
  "block.minecraft.crimson_trapdoor": "Blodlem",
  "block.minecraft.crimson_wall_hanging_sign": "Hangande blodskilt på vegg",
  "block.minecraft.crimson_wall_sign": "Blodveggskilt",
  "block.minecraft.crying_obsidian": "Gråtande ramntinna",
  "block.minecraft.cut_copper": "Skoren kopar",
  "block.minecraft.cut_copper_slab": "Hella av skoren kopar",
  "block.minecraft.cut_copper_stairs": "Tropp av skoren kopar",
  "block.minecraft.cut_red_sandstone": "Skoren raud sandstein",
  "block.minecraft.cut_red_sandstone_slab": "Hella av skoren raud sandstein",
  "block.minecraft.cut_sandstone": "Skoren sandstein",
  "block.minecraft.cut_sandstone_slab": "Hella av skoren sandstein",
  "block.minecraft.cyan_banner": "Blågrøn fana",
  "block.minecraft.cyan_bed": "Blågrøn seng",
  "block.minecraft.cyan_candle": "Blågrønt vaksljos",
  "block.minecraft.cyan_candle_cake": "Kaka med blågrønt vaksljos",
  "block.minecraft.cyan_carpet": "Blågrøn rya",
  "block.minecraft.cyan_concrete": "Blågrøn støypestein",
  "block.minecraft.cyan_concrete_powder": "Blågrøn støypesteinsdumba",
  "block.minecraft.cyan_glazed_terracotta": "Blågrøn glasad terrakotta",
  "block.minecraft.cyan_shulker_box": "Blågrønt shulkerhus",
  "block.minecraft.cyan_stained_glass": "Blågrønlìtat glas",
  "block.minecraft.cyan_stained_glass_pane": "Blågrønlìtad glasruta",
  "block.minecraft.cyan_terracotta": "Blågrøn terrakotta",
  "block.minecraft.cyan_wool": "Blågrøn ull",
  "block.minecraft.damaged_anvil": "Skadt sted",
  "block.minecraft.dandelion": "Gullboste",
  "block.minecraft.dark_oak_button": "Myrkeikeknapp",
  "block.minecraft.dark_oak_door": "Myrkeikedỳr",
  "block.minecraft.dark_oak_fence": "Myrkeikegard",
  "block.minecraft.dark_oak_fence_gate": "Myrkeikegrind",
  "block.minecraft.dark_oak_hanging_sign": "Hangande myrkeikeskilt på vegg",
  "block.minecraft.dark_oak_leaves": "Myrkeikelauv",
  "block.minecraft.dark_oak_log": "Myrkeikestomn",
  "block.minecraft.dark_oak_planks": "Myrkeikebord",
  "block.minecraft.dark_oak_pressure_plate": "Myrkeike-tyngdarfjøl",
  "block.minecraft.dark_oak_sapling": "Myrkeikerenning",
  "block.minecraft.dark_oak_shelf": "Myrkeikehylla",
  "block.minecraft.dark_oak_sign": "Myrkeikeskilt",
  "block.minecraft.dark_oak_slab": "Myrkeikehelle",
  "block.minecraft.dark_oak_stairs": "Myrkeiketropp",
  "block.minecraft.dark_oak_trapdoor": "Myrkeikelem",
  "block.minecraft.dark_oak_wall_hanging_sign": "Hangande myrkeikeskilt på vegg",
  "block.minecraft.dark_oak_wall_sign": "Myrkeikeveggskilt",
  "block.minecraft.dark_oak_wood": "Myrkeikevìd",
  "block.minecraft.dark_prismarine": "Myrkprismarin",
  "block.minecraft.dark_prismarine_slab": "Myrkprismarin-helle",
  "block.minecraft.dark_prismarine_stairs": "Myrkprismarin-tropp",
  "block.minecraft.daylight_detector": "Dagsljosmålar",
  "block.minecraft.dead_brain_coral": "Daud heilekorall",
  "block.minecraft.dead_brain_coral_block": "Daud heilekorallblokk",
  "block.minecraft.dead_brain_coral_fan": "Daud heilekorallveifta",
  "block.minecraft.dead_brain_coral_wall_fan": "Daud heilekorallveggveifta",
  "block.minecraft.dead_bubble_coral": "Daud blørekorall",
  "block.minecraft.dead_bubble_coral_block": "Daud blørekorallblokk",
  "block.minecraft.dead_bubble_coral_fan": "Daud blørekorallveifta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Daud blørekorallveggveifta",
  "block.minecraft.dead_bush": "Daud runn",
  "block.minecraft.dead_fire_coral": "Daud eldkorall",
  "block.minecraft.dead_fire_coral_block": "Daud eldkorallblokk",
  "block.minecraft.dead_fire_coral_fan": "Daud eldkorallveifta",
  "block.minecraft.dead_fire_coral_wall_fan": "Daud eldkorallveggveifta",
  "block.minecraft.dead_horn_coral": "Daud hornkorall",
  "block.minecraft.dead_horn_coral_block": "Daud hornkorallblokk",
  "block.minecraft.dead_horn_coral_fan": "Daud hornkorallveifta",
  "block.minecraft.dead_horn_coral_wall_fan": "Daud hornkorallveggveifta",
  "block.minecraft.dead_tube_coral": "Daud orgekorall",
  "block.minecraft.dead_tube_coral_block": "Daud orgekorallblokk",
  "block.minecraft.dead_tube_coral_fan": "Daud orgekorallveifta",
  "block.minecraft.dead_tube_coral_wall_fan": "Daud orgekorallveggveifta",
  "block.minecraft.decorated_pot": "Prydd potta",
  "block.minecraft.deepslate": "Djupskifer",
  "block.minecraft.deepslate_brick_slab": "Hella av djupskifertigl",
  "block.minecraft.deepslate_brick_stairs": "Tropp av djupskifertigl",
  "block.minecraft.deepslate_brick_wall": "Vegg av djupskifertigl",
  "block.minecraft.deepslate_bricks": "Djupskifertigl",
  "block.minecraft.deepslate_coal_ore": "Kolmalm i djupskifer",
  "block.minecraft.deepslate_copper_ore": "Koparmalm i djupskifer",
  "block.minecraft.deepslate_diamond_ore": "Demantår i djupskifer",
  "block.minecraft.deepslate_emerald_ore": "Smaragdår i djupskifer",
  "block.minecraft.deepslate_gold_ore": "Gullmalm i djupskifer",
  "block.minecraft.deepslate_iron_ore": "Jarnmalm i djupskifer",
  "block.minecraft.deepslate_lapis_ore": "Lasursteinår i djupskifer",
  "block.minecraft.deepslate_redstone_ore": "Redstonemalm i djupskifer",
  "block.minecraft.deepslate_tile_slab": "Hella av djupskiferflisar",
  "block.minecraft.deepslate_tile_stairs": "Tropp av djupskiferflisar",
  "block.minecraft.deepslate_tile_wall": "Vegg av djupskiferflisar",
  "block.minecraft.deepslate_tiles": "Djupskiferflisar",
  "block.minecraft.detector_rail": "Merkarskjena",
  "block.minecraft.diamond_block": "Demantblokk",
  "block.minecraft.diamond_ore": "Demantår",
  "block.minecraft.diorite": "Dioritt",
  "block.minecraft.diorite_slab": "Dioritthella",
  "block.minecraft.diorite_stairs": "Diorittropp",
  "block.minecraft.diorite_wall": "Diorittvegg",
  "block.minecraft.dirt": "Mold",
  "block.minecraft.dirt_path": "Moldrås",
  "block.minecraft.dispenser": "Utskjotar",
  "block.minecraft.dragon_egg": "Drakeegg",
  "block.minecraft.dragon_head": "Drakehovud",
  "block.minecraft.dragon_wall_head": "Drakevegghovud",
  "block.minecraft.dried_ghast": "Innturkat ghast",
  "block.minecraft.dried_kelp_block": "Blokk av turkad tare",
  "block.minecraft.dripstone_block": "Dropsteinsblokk",
  "block.minecraft.dropper": "Sleppar",
  "block.minecraft.emerald_block": "Smaragdblokk",
  "block.minecraft.emerald_ore": "Smaragdår",
  "block.minecraft.enchanting_table": "Galdrebord",
  "block.minecraft.end_gateway": "Endegat",
  "block.minecraft.end_portal": "Endelìd",
  "block.minecraft.end_portal_frame": "Endelìdsråma",
  "block.minecraft.end_rod": "Endestong",
  "block.minecraft.end_stone": "Endestein",
  "block.minecraft.end_stone_brick_slab": "Hella av endesteinstigl",
  "block.minecraft.end_stone_brick_stairs": "Tropp av endesteinstigl",
  "block.minecraft.end_stone_brick_wall": "Vegg av endesteinstigl",
  "block.minecraft.end_stone_bricks": "Endesteinstigl",
  "block.minecraft.ender_chest": "Enderkista",
  "block.minecraft.exposed_chiseled_copper": "Utsett meitlad kopar",
  "block.minecraft.exposed_copper": "Utsett kopar",
  "block.minecraft.exposed_copper_bars": "Utsett kopargrind",
  "block.minecraft.exposed_copper_bulb": "Utsett koparpera",
  "block.minecraft.exposed_copper_chain": "Utsett koparkjedja",
  "block.minecraft.exposed_copper_chest": "Utsett koparkista",
  "block.minecraft.exposed_copper_door": "Utsett kopardỳr",
  "block.minecraft.exposed_copper_golem_statue": "Utsett eirgjengelstytta",
  "block.minecraft.exposed_copper_grate": "Utsett koparrist",
  "block.minecraft.exposed_copper_lantern": "Utsett koparlykt",
  "block.minecraft.exposed_copper_trapdoor": "Utsett koparlem",
  "block.minecraft.exposed_cut_copper": "Utsett skoren kopar",
  "block.minecraft.exposed_cut_copper_slab": "Utsett hella av skoren kopar",
  "block.minecraft.exposed_cut_copper_stairs": "Utsett tropp av skoren kopar",
  "block.minecraft.exposed_lightning_rod": "Utsett eldingavleidar",
  "block.minecraft.farmland": "Åker",
  "block.minecraft.fern": "Burkne",
  "block.minecraft.fire": "Eld",
  "block.minecraft.fire_coral": "Eldkorall",
  "block.minecraft.fire_coral_block": "Eldkorallblokk",
  "block.minecraft.fire_coral_fan": "Eldkorallveifta",
  "block.minecraft.fire_coral_wall_fan": "Eldkorallveggveifta",
  "block.minecraft.firefly_bush": "Eldflugerunn",
  "block.minecraft.fletching_table": "Pilmakarbord",
  "block.minecraft.flower_pot": "Blompotta",
  "block.minecraft.flowering_azalea": "Blømande lyngrosa",
  "block.minecraft.flowering_azalea_leaves": "Blømande lyngroselauv",
  "block.minecraft.frogspawn": "Froskegot",
  "block.minecraft.frosted_ice": "Rimlagd is",
  "block.minecraft.furnace": "Omn",
  "block.minecraft.gilded_blackstone": "Gylt svartstein",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasruta",
  "block.minecraft.glow_lichen": "Glødelav",
  "block.minecraft.glowstone": "Glødestein",
  "block.minecraft.gold_block": "Gullblokk",
  "block.minecraft.gold_ore": "Gullmalm",
  "block.minecraft.golden_dandelion": "Gull-boste",
  "block.minecraft.granite": "Granitt",
  "block.minecraft.granite_slab": "Granitthella",
  "block.minecraft.granite_stairs": "Granittropp",
  "block.minecraft.granite_wall": "Granittvegg",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblokk",
  "block.minecraft.gravel": "Aur",
  "block.minecraft.gray_banner": "Grå fana",
  "block.minecraft.gray_bed": "Grå seng",
  "block.minecraft.gray_candle": "Grått vaksljos",
  "block.minecraft.gray_candle_cake": "Kaka med grått vaksljos",
  "block.minecraft.gray_carpet": "Grå rya",
  "block.minecraft.gray_concrete": "Grå støypestein",
  "block.minecraft.gray_concrete_powder": "Grå støypesteinsdumba",
  "block.minecraft.gray_glazed_terracotta": "Grå glasad terrakotta",
  "block.minecraft.gray_shulker_box": "Grått shulkerhus",
  "block.minecraft.gray_stained_glass": "Grålìtat glas",
  "block.minecraft.gray_stained_glass_pane": "Grålìtad glasruta",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå ull",
  "block.minecraft.green_banner": "Grøn fana",
  "block.minecraft.green_bed": "Grøn seng",
  "block.minecraft.green_candle": "Grønt vaksljos",
  "block.minecraft.green_candle_cake": "Kaka med grønt vaksljos",
  "block.minecraft.green_carpet": "Grøn rya",
  "block.minecraft.green_concrete": "Grøn støypestein",
  "block.minecraft.green_concrete_powder": "Grøn støypesteinsdumba",
  "block.minecraft.green_glazed_terracotta": "Grøn glasad terracotta",
  "block.minecraft.green_shulker_box": "Grønt shulkerhus",
  "block.minecraft.green_stained_glass": "Grønlìtat glas",
  "block.minecraft.green_stained_glass_pane": "Grønlìtad glasruta",
  "block.minecraft.green_terracotta": "Grøn terrakotta",
  "block.minecraft.green_wool": "Grøn ull",
  "block.minecraft.grindstone": "Slipestein",
  "block.minecraft.hanging_roots": "Hangande røter",
  "block.minecraft.hay_block": "Høystakk",
  "block.minecraft.heavy_core": "Tung kjerne",
  "block.minecraft.heavy_weighted_pressure_plate": "Tung-tyngdarfjøl",
  "block.minecraft.honey_block": "Huningblokk",
  "block.minecraft.honeycomb_block": "Vakskakeblokk",
  "block.minecraft.hopper": "Trekt",
  "block.minecraft.horn_coral": "Hornkorall",
  "block.minecraft.horn_coral_block": "Hornkorallblokk",
  "block.minecraft.horn_coral_fan": "Hornkorallveifta",
  "block.minecraft.horn_coral_wall_fan": "Hornkorallveggveifta",
  "block.minecraft.ice": "Is",
  "block.minecraft.infested_chiseled_stone_bricks": "Fengt meitlat steintigl",
  "block.minecraft.infested_cobblestone": "Fengd brustein",
  "block.minecraft.infested_cracked_stone_bricks": "Fengd sprokken steintigl",
  "block.minecraft.infested_deepslate": "Fengd djupskifer",
  "block.minecraft.infested_mossy_stone_bricks": "Fengd mosegrott steintigl",
  "block.minecraft.infested_stone": "Fengd stein",
  "block.minecraft.infested_stone_bricks": "Fengd steintigl",
  "block.minecraft.iron_bars": "Jarngrind",
  "block.minecraft.iron_block": "Jarnblokk",
  "block.minecraft.iron_chain": "Jern Kjede",
  "block.minecraft.iron_door": "Jarndỳr",
  "block.minecraft.iron_ore": "Jarnmalm",
  "block.minecraft.iron_trapdoor": "Jarnlem",
  "block.minecraft.jack_o_lantern": "Graskarlykt",
  "block.minecraft.jigsaw": "Pusleblokk",
  "block.minecraft.jukebox": "Skivespelar",
  "block.minecraft.jungle_button": "Regnskogsknapp",
  "block.minecraft.jungle_door": "Regnskogsdỳr",
  "block.minecraft.jungle_fence": "Regnskogsgard",
  "block.minecraft.jungle_fence_gate": "Regnskogsgrind",
  "block.minecraft.jungle_hanging_sign": "Hangande regnskogsskilt",
  "block.minecraft.jungle_leaves": "Regnskogslauv",
  "block.minecraft.jungle_log": "Regnskogsstomn",
  "block.minecraft.jungle_planks": "Regnskogsbord",
  "block.minecraft.jungle_pressure_plate": "Regnskogs-tyngdarfjøl",
  "block.minecraft.jungle_sapling": "Regnskogsrenning",
  "block.minecraft.jungle_shelf": "Regnskogshylla",
  "block.minecraft.jungle_sign": "Regnskogsskilt",
  "block.minecraft.jungle_slab": "Regnskogshella",
  "block.minecraft.jungle_stairs": "Regnskogstropp",
  "block.minecraft.jungle_trapdoor": "Regnskogslem",
  "block.minecraft.jungle_wall_hanging_sign": "Hangande regnskogsskilt på vegg",
  "block.minecraft.jungle_wall_sign": "Regnskogsveggskilt",
  "block.minecraft.jungle_wood": "Regnskogsvìd",
  "block.minecraft.kelp": "Tare",
  "block.minecraft.kelp_plant": "Tarevokster",
  "block.minecraft.ladder": "Stige",
  "block.minecraft.lantern": "Lykt",
  "block.minecraft.lapis_block": "Lasursteinsblokk",
  "block.minecraft.lapis_ore": "Lasursteinsår",
  "block.minecraft.large_amethyst_bud": "Stor ametystknupp",
  "block.minecraft.large_fern": "Stor burkne",
  "block.minecraft.lava": "Raun",
  "block.minecraft.lava_cauldron": "Raungryta",
  "block.minecraft.leaf_litter": "Lauvstrøy",
  "block.minecraft.lectern": "Bokstol",
  "block.minecraft.lever": "Handtak",
  "block.minecraft.light": "Ljos",
  "block.minecraft.light_blue_banner": "Ljosblå fana",
  "block.minecraft.light_blue_bed": "Ljosblå seng",
  "block.minecraft.light_blue_candle": "Ljosblått vaksljos",
  "block.minecraft.light_blue_candle_cake": "Kaka med ljosblått vaksljos",
  "block.minecraft.light_blue_carpet": "Ljosblå rya",
  "block.minecraft.light_blue_concrete": "Ljosblå støypestein",
  "block.minecraft.light_blue_concrete_powder": "Ljosblå støypesteinsdumba",
  "block.minecraft.light_blue_glazed_terracotta": "Ljosblå glasad terrakotta",
  "block.minecraft.light_blue_shulker_box": "Ljosblått shulkerhus",
  "block.minecraft.light_blue_stained_glass": "Ljosblålìtat glas",
  "block.minecraft.light_blue_stained_glass_pane": "Ljosblålìtad glasruta",
  "block.minecraft.light_blue_terracotta": "Ljosblå terrakotta",
  "block.minecraft.light_blue_wool": "Ljosblå ull",
  "block.minecraft.light_gray_banner": "Ljosgrå fana",
  "block.minecraft.light_gray_bed": "Ljosgrå seng",
  "block.minecraft.light_gray_candle": "Ljosgrått vaksljos",
  "block.minecraft.light_gray_candle_cake": "Kaka med ljosgrått vaksljos",
  "block.minecraft.light_gray_carpet": "Ljosgrå rya",
  "block.minecraft.light_gray_concrete": "Ljosgrå støypestein",
  "block.minecraft.light_gray_concrete_powder": "Ljosgrå støypesteinsdumba",
  "block.minecraft.light_gray_glazed_terracotta": "Ljosgrå glasad terrakotta",
  "block.minecraft.light_gray_shulker_box": "Ljosgrått shulkerhus",
  "block.minecraft.light_gray_stained_glass": "Ljosgrålìtat glas",
  "block.minecraft.light_gray_stained_glass_pane": "Ljosgrålìtad glasruta",
  "block.minecraft.light_gray_terracotta": "Ljosgrå terrakotta",
  "block.minecraft.light_gray_wool": "Ljosgrå ull",
  "block.minecraft.light_weighted_pressure_plate": "Lett-tyngdarfjøl",
  "block.minecraft.lightning_rod": "Eldingavleidar",
  "block.minecraft.lilac": "Syrin",
  "block.minecraft.lily_of_the_valley": "Rams",
  "block.minecraft.lily_pad": "Nykkjeblomblad",
  "block.minecraft.lime_banner": "Ljosgrøn fana",
  "block.minecraft.lime_bed": "Ljosgrøn seng",
  "block.minecraft.lime_candle": "Ljosgrønt vaksljos",
  "block.minecraft.lime_candle_cake": "Kaka med ljosgrønt vaksljos",
  "block.minecraft.lime_carpet": "Ljosgrøn rya",
  "block.minecraft.lime_concrete": "Ljosgrøn støypestein",
  "block.minecraft.lime_concrete_powder": "Ljosgrøn støypesteinsdumba",
  "block.minecraft.lime_glazed_terracotta": "Ljosgrøn glasad terrakotta",
  "block.minecraft.lime_shulker_box": "Ljosgrønt shulkerhus",
  "block.minecraft.lime_stained_glass": "Ljosgrønlìtat glas",
  "block.minecraft.lime_stained_glass_pane": "Ljosgrønlìtad glasruta",
  "block.minecraft.lime_terracotta": "Ljosgrøn terrakotta",
  "block.minecraft.lime_wool": "Ljosgrøn ull",
  "block.minecraft.lodestone": "Leidarstein",
  "block.minecraft.loom": "Vevstol",
  "block.minecraft.magenta_banner": "Ljosblåraud fana",
  "block.minecraft.magenta_bed": "Ljosblåraud seng",
  "block.minecraft.magenta_candle": "Ljosblåraudt vaksljos",
  "block.minecraft.magenta_candle_cake": "Kaka med ljosblåraudt vaksljos",
  "block.minecraft.magenta_carpet": "Ljosblåraud rya",
  "block.minecraft.magenta_concrete": "Ljosblåraud støypestein",
  "block.minecraft.magenta_concrete_powder": "Ljosblåraud støypesteinsdumba",
  "block.minecraft.magenta_glazed_terracotta": "Ljosblåraud glasad terrakotta",
  "block.minecraft.magenta_shulker_box": "Ljosblåraudt shulkerhus",
  "block.minecraft.magenta_stained_glass": "Ljosblåraudlìtat glas",
  "block.minecraft.magenta_stained_glass_pane": "Ljosblåraudlìtad glasruta",
  "block.minecraft.magenta_terracotta": "Ljosblåraud terrakotta",
  "block.minecraft.magenta_wool": "Ljosblåraud ull",
  "block.minecraft.magma_block": "Raunblokk",
  "block.minecraft.mangrove_button": "Mangroveknapp",
  "block.minecraft.mangrove_door": "Mangrovedỳr",
  "block.minecraft.mangrove_fence": "Mangrovegard",
  "block.minecraft.mangrove_fence_gate": "Mangrovegrind",
  "block.minecraft.mangrove_hanging_sign": "Hangande mangroveskilt",
  "block.minecraft.mangrove_leaves": "Mangrovelauv",
  "block.minecraft.mangrove_log": "Mangrovestomn",
  "block.minecraft.mangrove_planks": "Mangrovebord",
  "block.minecraft.mangrove_pressure_plate": "Mangrove-tyngdarfjøl",
  "block.minecraft.mangrove_propagule": "Mangrovefrjo",
  "block.minecraft.mangrove_roots": "Mangroverøter",
  "block.minecraft.mangrove_shelf": "Mangrovehylla",
  "block.minecraft.mangrove_sign": "Mangroveskilt",
  "block.minecraft.mangrove_slab": "Mangrovehella",
  "block.minecraft.mangrove_stairs": "Mangrovetropp",
  "block.minecraft.mangrove_trapdoor": "Mangrovelem",
  "block.minecraft.mangrove_wall_hanging_sign": "Hangande mangroveskilt på vegg",
  "block.minecraft.mangrove_wall_sign": "Mangroveveggskilt",
  "block.minecraft.mangrove_wood": "Mangrovevìd",
  "block.minecraft.medium_amethyst_bud": "Millomstor ametystknupp",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonstylk",
  "block.minecraft.moss_block": "Moseblokk",
  "block.minecraft.moss_carpet": "Mosebreidsla",
  "block.minecraft.mossy_cobblestone": "Mosegrodd brustein",
  "block.minecraft.mossy_cobblestone_slab": "Mosegrodd brusteinshella",
  "block.minecraft.mossy_cobblestone_stairs": "Mosegrodd brusteinstropp",
  "block.minecraft.mossy_cobblestone_wall": "Mosegrodd brusteinsvegg",
  "block.minecraft.mossy_stone_brick_slab": "Mosegrodd steintiglhella",
  "block.minecraft.mossy_stone_brick_stairs": "Mosegrodd steintigltropp",
  "block.minecraft.mossy_stone_brick_wall": "Mosegrodd steintiglvegg",
  "block.minecraft.mossy_stone_bricks": "Mosegrott steintigl",
  "block.minecraft.moving_piston": "Stempel i rørsla",
  "block.minecraft.mud": "Gyrma",
  "block.minecraft.mud_brick_slab": "Gyrmetiglhella",
  "block.minecraft.mud_brick_stairs": "Gyrmetigltropp",
  "block.minecraft.mud_brick_wall": "Gyrmetiglvegg",
  "block.minecraft.mud_bricks": "Gyrmetigl",
  "block.minecraft.muddy_mangrove_roots": "Gyrmute mangroverøter",
  "block.minecraft.mushroom_stem": "Soppstylk",
  "block.minecraft.mycelium": "Soppvev",
  "block.minecraft.nether_brick_fence": "Nethertiglgard",
  "block.minecraft.nether_brick_slab": "Nethertiglhella",
  "block.minecraft.nether_brick_stairs": "Nethertigltropp",
  "block.minecraft.nether_brick_wall": "Nethertiglvegg",
  "block.minecraft.nether_bricks": "Nethertigl",
  "block.minecraft.nether_gold_ore": "Nethergullmalm",
  "block.minecraft.nether_portal": "Netherlìd",
  "block.minecraft.nether_quartz_ore": "Netherkattsteins-år",
  "block.minecraft.nether_sprouts": "Netherspiror",
  "block.minecraft.nether_wart": "Nethervòrta",
  "block.minecraft.nether_wart_block": "Nethervòrteblokk",
  "block.minecraft.netherite_block": "Netherittblokk",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noteblokk",
  "block.minecraft.oak_button": "Eikeknapp",
  "block.minecraft.oak_door": "Eikedỳr",
  "block.minecraft.oak_fence": "Eikegard",
  "block.minecraft.oak_fence_gate": "Eikegrind",
  "block.minecraft.oak_hanging_sign": "Hangande eikeskilt",
  "block.minecraft.oak_leaves": "Eikelauv",
  "block.minecraft.oak_log": "Eikestomn",
  "block.minecraft.oak_planks": "Eikebord",
  "block.minecraft.oak_pressure_plate": "Eike-tyngdarfjøl",
  "block.minecraft.oak_sapling": "Eikerenning",
  "block.minecraft.oak_shelf": "Eikehylla",
  "block.minecraft.oak_sign": "Eikeskilt",
  "block.minecraft.oak_slab": "Eikehella",
  "block.minecraft.oak_stairs": "Eiketropp",
  "block.minecraft.oak_trapdoor": "Eikelem",
  "block.minecraft.oak_wall_hanging_sign": "Hangande eikeskilt på vegg",
  "block.minecraft.oak_wall_sign": "Eikeveggskilt",
  "block.minecraft.oak_wood": "Eikevìd",
  "block.minecraft.observer": "Utkikar",
  "block.minecraft.obsidian": "Ramntinna",
  "block.minecraft.ochre_froglight": "Gulbrunt froskeljos",
  "block.minecraft.ominous_banner": "Illspåi fana",
  "block.minecraft.open_eyeblossom": "Open augblom",
  "block.minecraft.orange_banner": "Brandgul fana",
  "block.minecraft.orange_bed": "Brandgul seng",
  "block.minecraft.orange_candle": "Brandgult vaksljos",
  "block.minecraft.orange_candle_cake": "Kaka med brandgult vaksljos",
  "block.minecraft.orange_carpet": "Brandgul rya",
  "block.minecraft.orange_concrete": "Brandgul støypestein",
  "block.minecraft.orange_concrete_powder": "Brandgul støypesteinsdumba",
  "block.minecraft.orange_glazed_terracotta": "Brandgul glasad terrakotta",
  "block.minecraft.orange_shulker_box": "Brandgult shulkerhus",
  "block.minecraft.orange_stained_glass": "Brandgullìtat glas",
  "block.minecraft.orange_stained_glass_pane": "Brandgullìtad glasruta",
  "block.minecraft.orange_terracotta": "Brandgul terrakotta",
  "block.minecraft.orange_tulip": "Brandgul tulipan",
  "block.minecraft.orange_wool": "Brandgul ull",
  "block.minecraft.oxeye_daisy": "Balderbrå",
  "block.minecraft.oxidized_chiseled_copper": "Eirad meitlad kopar",
  "block.minecraft.oxidized_copper": "Eirad koparblokk",
  "block.minecraft.oxidized_copper_bars": "Eirad kopargrind",
  "block.minecraft.oxidized_copper_bulb": "Eirad koparpera",
  "block.minecraft.oxidized_copper_chain": "Eirad koparkjedja",
  "block.minecraft.oxidized_copper_chest": "Eirad koparkista",
  "block.minecraft.oxidized_copper_door": "Eirad kopardỳr",
  "block.minecraft.oxidized_copper_golem_statue": "Eirad eirgjengelstytta",
  "block.minecraft.oxidized_copper_grate": "Eirad koparrist",
  "block.minecraft.oxidized_copper_lantern": "Eirad koparlykt",
  "block.minecraft.oxidized_copper_trapdoor": "Eirad koparlem",
  "block.minecraft.oxidized_cut_copper": "Eirad skoren kopar",
  "block.minecraft.oxidized_cut_copper_slab": "Eirad hella av skoren kopar",
  "block.minecraft.oxidized_cut_copper_stairs": "Eirad tropp av skoren kopar",
  "block.minecraft.oxidized_lightning_rod": "Eirad eldingavleidar",
  "block.minecraft.packed_ice": "Pakkis",
  "block.minecraft.packed_mud": "Pakkgyrma",
  "block.minecraft.pale_hanging_moss": "Hangande bleikmose",
  "block.minecraft.pale_moss_block": "Bleikmoseblokk",
  "block.minecraft.pale_moss_carpet": "Bleikmoserya",
  "block.minecraft.pale_oak_button": "Bleikeikeknapp",
  "block.minecraft.pale_oak_door": "Bleikeikedỳr",
  "block.minecraft.pale_oak_fence": "Bleikeikegard",
  "block.minecraft.pale_oak_fence_gate": "Bleikeikegrind",
  "block.minecraft.pale_oak_hanging_sign": "Hangande bleikeikeskilt",
  "block.minecraft.pale_oak_leaves": "Bleikeikelauv",
  "block.minecraft.pale_oak_log": "Bleikeikestomn",
  "block.minecraft.pale_oak_planks": "Bleikeikebord",
  "block.minecraft.pale_oak_pressure_plate": "Bleikeike-tyngdarfjøl",
  "block.minecraft.pale_oak_sapling": "Bleikeikerenning",
  "block.minecraft.pale_oak_shelf": "Bleikeikehylla",
  "block.minecraft.pale_oak_sign": "Bleikeikeskilt",
  "block.minecraft.pale_oak_slab": "Bleikeikehella",
  "block.minecraft.pale_oak_stairs": "Bleikeiketropp",
  "block.minecraft.pale_oak_trapdoor": "Bleikeikelem",
  "block.minecraft.pale_oak_wall_hanging_sign": "Hangande bleikeikeskilt på vegg",
  "block.minecraft.pale_oak_wall_sign": "Bleikeikeveggskilt",
  "block.minecraft.pale_oak_wood": "Bleikeikevìd",
  "block.minecraft.pearlescent_froglight": "Perleskimrande froskeljos",
  "block.minecraft.peony": "Bonderosa",
  "block.minecraft.petrified_oak_slab": "Steingjengi eikehella",
  "block.minecraft.piglin_head": "Piglinhovud",
  "block.minecraft.piglin_wall_head": "Piglinvegghovud",
  "block.minecraft.pink_banner": "Ljosraud fana",
  "block.minecraft.pink_bed": "Ljosraud seng",
  "block.minecraft.pink_candle": "Ljosraudt vaksljos",
  "block.minecraft.pink_candle_cake": "Kaka med ljosraudt vaksljos",
  "block.minecraft.pink_carpet": "Ljosraud rya",
  "block.minecraft.pink_concrete": "Ljosraud støypestein",
  "block.minecraft.pink_concrete_powder": "Ljosraud støypesteindumba",
  "block.minecraft.pink_glazed_terracotta": "Ljosraud glasad terrakotta",
  "block.minecraft.pink_petals": "Ljosraude kronblad",
  "block.minecraft.pink_shulker_box": "Ljosraudt shulkerhus",
  "block.minecraft.pink_stained_glass": "Ljosraudlìtat glas",
  "block.minecraft.pink_stained_glass_pane": "Ljosraudlìtad glasruta",
  "block.minecraft.pink_terracotta": "Ljosraud terrakotta",
  "block.minecraft.pink_tulip": "Ljosraud tulipan",
  "block.minecraft.pink_wool": "Ljosraud ull",
  "block.minecraft.piston": "Stempel",
  "block.minecraft.piston_head": "Stempelhovud",
  "block.minecraft.pitcher_crop": "Kanneavling",
  "block.minecraft.pitcher_plant": "Kannerot",
  "block.minecraft.player_head": "Leikarhovud",
  "block.minecraft.player_head.named": "Hovudet åt %s",
  "block.minecraft.player_wall_head": "Leikarvegghovud",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Kvass dropstein",
  "block.minecraft.polished_andesite": "Finslipen andesitt",
  "block.minecraft.polished_andesite_slab": "Hella av finslipen andesitt",
  "block.minecraft.polished_andesite_stairs": "Tropp av finslipen andesitt",
  "block.minecraft.polished_basalt": "Finslipen basalt",
  "block.minecraft.polished_blackstone": "Finslipen svartstein",
  "block.minecraft.polished_blackstone_brick_slab": "Hella av finslipet svartsteinstigl",
  "block.minecraft.polished_blackstone_brick_stairs": "Tropp av finslipet svartsteinstigl",
  "block.minecraft.polished_blackstone_brick_wall": "Vegg av finslipet svartsteinstigl",
  "block.minecraft.polished_blackstone_bricks": "Finslipet svartsteinstigl",
  "block.minecraft.polished_blackstone_button": "Knapp av finslipen svartstein",
  "block.minecraft.polished_blackstone_pressure_plate": "Tyngdarfjøl av finslipen svartstein",
  "block.minecraft.polished_blackstone_slab": "Hella av finslipen svartstein",
  "block.minecraft.polished_blackstone_stairs": "Tropp av finslipen svartstein",
  "block.minecraft.polished_blackstone_wall": "Vegg av finslipen svartstein",
  "block.minecraft.polished_deepslate": "Finslipen djupskifer",
  "block.minecraft.polished_deepslate_slab": "Hella av finslipen djupskifer",
  "block.minecraft.polished_deepslate_stairs": "Tropp av finslipen djupskifer",
  "block.minecraft.polished_deepslate_wall": "Vegg av finslipen djupskifer",
  "block.minecraft.polished_diorite": "Finslipen dioritt",
  "block.minecraft.polished_diorite_slab": "Hella av finslipen dioritt",
  "block.minecraft.polished_diorite_stairs": "Tropp av finslipen dioritt",
  "block.minecraft.polished_granite": "Finslipen granitt",
  "block.minecraft.polished_granite_slab": "Hella av finslipen granitt",
  "block.minecraft.polished_granite_stairs": "Tropp av finslipen granitt",
  "block.minecraft.polished_tuff": "Finslipen tuff",
  "block.minecraft.polished_tuff_slab": "Hella av finslipen tuff",
  "block.minecraft.polished_tuff_stairs": "Tropp av finslipen tuff",
  "block.minecraft.polished_tuff_wall": "Vegg av finslipen tuff",
  "block.minecraft.poppy": "Valmoe",
  "block.minecraft.potatoes": "Jordeple",
  "block.minecraft.potted_acacia_sapling": "Akasierenning i potta",
  "block.minecraft.potted_allium": "Villauk i potta",
  "block.minecraft.potted_azalea_bush": "Lyngrosa i potta",
  "block.minecraft.potted_azure_bluet": "Houstonia i potta",
  "block.minecraft.potted_bamboo": "Bambus i potta",
  "block.minecraft.potted_birch_sapling": "Bjørkarrenning i potta",
  "block.minecraft.potted_blue_orchid": "Blå orkidé i potta",
  "block.minecraft.potted_brown_mushroom": "Brun sopp i potta",
  "block.minecraft.potted_cactus": "Kaktus i potta",
  "block.minecraft.potted_cherry_sapling": "Kisseberrenning i potta",
  "block.minecraft.potted_closed_eyeblossom": "Attlaten augblom i potta",
  "block.minecraft.potted_cornflower": "Kornblom i potta",
  "block.minecraft.potted_crimson_fungus": "Blodsopp i potta",
  "block.minecraft.potted_crimson_roots": "Blodrøter i potta",
  "block.minecraft.potted_dandelion": "Gullboste i potta",
  "block.minecraft.potted_dark_oak_sapling": "Myrkeikerenning i potta",
  "block.minecraft.potted_dead_bush": "Daud runn i potta",
  "block.minecraft.potted_fern": "Burkne i potta",
  "block.minecraft.potted_flowering_azalea_bush": "Blømande lyngrosa i potta",
  "block.minecraft.potted_golden_dandelion": "Gull-boste i potta",
  "block.minecraft.potted_jungle_sapling": "Regnskogsrenning i potta",
  "block.minecraft.potted_lily_of_the_valley": "Rams i potta",
  "block.minecraft.potted_mangrove_propagule": "Mangrovefrjo i potta",
  "block.minecraft.potted_oak_sapling": "Eikerenning i potta",
  "block.minecraft.potted_open_eyeblossom": "Open augblom i potta",
  "block.minecraft.potted_orange_tulip": "Brandgul tulipan i potta",
  "block.minecraft.potted_oxeye_daisy": "Balderbrå i potta",
  "block.minecraft.potted_pale_oak_sapling": "Bleikeik i potta",
  "block.minecraft.potted_pink_tulip": "Ljosraud tulipan i potta",
  "block.minecraft.potted_poppy": "Valmoe i potta",
  "block.minecraft.potted_red_mushroom": "Flugesopp i potta",
  "block.minecraft.potted_red_tulip": "Raud tulipan i potta",
  "block.minecraft.potted_spruce_sapling": "Granrenning i potta",
  "block.minecraft.potted_torchflower": "Kyndelblom i potta",
  "block.minecraft.potted_warped_fungus": "Vrìdsopp i potta",
  "block.minecraft.potted_warped_roots": "Vrìdrøter i potta",
  "block.minecraft.potted_white_tulip": "Kvit tulipan i potta",
  "block.minecraft.potted_wither_rose": "Witherrosa i potta",
  "block.minecraft.powder_snow": "Mjøll",
  "block.minecraft.powder_snow_cauldron": "Mjøllgryta",
  "block.minecraft.powered_rail": "Straumskjena",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarintiglhella",
  "block.minecraft.prismarine_brick_stairs": "Prismarintigltropp",
  "block.minecraft.prismarine_bricks": "Prismarintigl",
  "block.minecraft.prismarine_slab": "Prismarinhella",
  "block.minecraft.prismarine_stairs": "Prismarintropp",
  "block.minecraft.prismarine_wall": "Prismarinvegg",
  "block.minecraft.pumpkin": "Graskjer",
  "block.minecraft.pumpkin_stem": "Graskjerstylk",
  "block.minecraft.purple_banner": "Blåraud fana",
  "block.minecraft.purple_bed": "Blåraud seng",
  "block.minecraft.purple_candle": "Blåraudt vaksljos",
  "block.minecraft.purple_candle_cake": "Kaka med blåraudt vaksljos",
  "block.minecraft.purple_carpet": "Blåraud rya",
  "block.minecraft.purple_concrete": "Blåraud støypestein",
  "block.minecraft.purple_concrete_powder": "Blåraud støypesteinsdumba",
  "block.minecraft.purple_glazed_terracotta": "Blåraud glasad terrakotta",
  "block.minecraft.purple_shulker_box": "Blåraudt shulkerhus",
  "block.minecraft.purple_stained_glass": "Blåraudlìtat glas",
  "block.minecraft.purple_stained_glass_pane": "Blåraudlìtad glasruta",
  "block.minecraft.purple_terracotta": "Blåraud terrakotta",
  "block.minecraft.purple_wool": "Blåraud ull",
  "block.minecraft.purpur_block": "Purpurblokk",
  "block.minecraft.purpur_pillar": "Purpursula",
  "block.minecraft.purpur_slab": "Purpurhella",
  "block.minecraft.purpur_stairs": "Purpurtropp",
  "block.minecraft.quartz_block": "Kattsteinsblokk",
  "block.minecraft.quartz_bricks": "Kattsteinstigl",
  "block.minecraft.quartz_pillar": "Kattsteinssula",
  "block.minecraft.quartz_slab": "Kattsteinshella",
  "block.minecraft.quartz_stairs": "Kattsteinstropp",
  "block.minecraft.rail": "Skjena",
  "block.minecraft.raw_copper_block": "Råkoparblokk",
  "block.minecraft.raw_gold_block": "Rågullsblokk",
  "block.minecraft.raw_iron_block": "Råjarnsblokk",
  "block.minecraft.red_banner": "Raud fana",
  "block.minecraft.red_bed": "Raud seng",
  "block.minecraft.red_candle": "Raudt vaksljos",
  "block.minecraft.red_candle_cake": "Kaka med raudt vaksljos",
  "block.minecraft.red_carpet": "Raud rya",
  "block.minecraft.red_concrete": "Raud støypestein",
  "block.minecraft.red_concrete_powder": "Raud støypesteinsdumba",
  "block.minecraft.red_glazed_terracotta": "Raud glasad terrakotta",
  "block.minecraft.red_mushroom": "Flugesopp",
  "block.minecraft.red_mushroom_block": "Flugesoppblokk",
  "block.minecraft.red_nether_brick_slab": "Hella av raudt nethertigl",
  "block.minecraft.red_nether_brick_stairs": "Tropp av raudt nethertigl",
  "block.minecraft.red_nether_brick_wall": "Vegg av raudt nethertigl",
  "block.minecraft.red_nether_bricks": "Raudt nethertigl",
  "block.minecraft.red_sand": "Raud sand",
  "block.minecraft.red_sandstone": "Raud sandstein",
  "block.minecraft.red_sandstone_slab": "Hella av raud sandstein",
  "block.minecraft.red_sandstone_stairs": "Tropp av raud sandstein",
  "block.minecraft.red_sandstone_wall": "Vegg av raud sandstein",
  "block.minecraft.red_shulker_box": "Raud shulkerhus",
  "block.minecraft.red_stained_glass": "Raudlìtat glas",
  "block.minecraft.red_stained_glass_pane": "Raudlìtad glasruta",
  "block.minecraft.red_terracotta": "Raud terrakotta",
  "block.minecraft.red_tulip": "Raud tulipan",
  "block.minecraft.red_wool": "Raud ull",
  "block.minecraft.redstone_block": "Redstoneblokk",
  "block.minecraft.redstone_lamp": "Redstonelampe",
  "block.minecraft.redstone_ore": "Redstonemalm",
  "block.minecraft.redstone_torch": "Redstonekyndel",
  "block.minecraft.redstone_wall_torch": "Veggredstonekyndel",
  "block.minecraft.redstone_wire": "Redstoneleidning",
  "block.minecraft.reinforced_deepslate": "Styrkt djupskifer",
  "block.minecraft.repeater": "Redstoneaukar",
  "block.minecraft.repeating_command_block": "Uppattakande styrebòdsblokk",
  "block.minecraft.resin_block": "Kvådeblokk",
  "block.minecraft.resin_brick_slab": "Kvådetiglhella",
  "block.minecraft.resin_brick_stairs": "Kvådetigltropp",
  "block.minecraft.resin_brick_wall": "Kvådetiglvegg",
  "block.minecraft.resin_bricks": "Kvådetigl",
  "block.minecraft.resin_clump": "Kvådeklump",
  "block.minecraft.respawn_anchor": "Uppstòdeakkjer",
  "block.minecraft.rooted_dirt": "Røtt mold",
  "block.minecraft.rose_bush": "Klunger",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstein",
  "block.minecraft.sandstone_slab": "Sandsteinshella",
  "block.minecraft.sandstone_stairs": "Sandsteinstropp",
  "block.minecraft.sandstone_wall": "Sandsteinsvegg",
  "block.minecraft.scaffolding": "Stelling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkeskundar",
  "block.minecraft.sculk_sensor": "Sculkegaumar",
  "block.minecraft.sculk_shrieker": "Sculkeskrikar",
  "block.minecraft.sculk_vein": "Sculkeår",
  "block.minecraft.sea_lantern": "Sjolykt",
  "block.minecraft.sea_pickle": "Sjoagurk",
  "block.minecraft.seagrass": "Sjogras",
  "block.minecraft.set_spawn": "Sette uppstòdestad",
  "block.minecraft.short_dry_grass": "Stutt turt gras",
  "block.minecraft.short_grass": "Stutt gras",
  "block.minecraft.shroomlight": "Lampinjong",
  "block.minecraft.shulker_box": "Shulkerhus",
  "block.minecraft.skeleton_skull": "Skalle",
  "block.minecraft.skeleton_wall_skull": "Veggskalle",
  "block.minecraft.slime_block": "Slimblokk",
  "block.minecraft.small_amethyst_bud": "Liten ametystknupp",
  "block.minecraft.small_dripleaf": "Litet droplauv",
  "block.minecraft.smithing_table": "Smidjebord",
  "block.minecraft.smoker": "Røykjaromn",
  "block.minecraft.smooth_basalt": "Jamn basalt",
  "block.minecraft.smooth_quartz": "Jòmn kattsteinsblokk",
  "block.minecraft.smooth_quartz_slab": "Hella av jamn kattstein",
  "block.minecraft.smooth_quartz_stairs": "Tropp av jamn kattstein",
  "block.minecraft.smooth_red_sandstone": "Jamn raud sandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Hella av jamn raud sandstein",
  "block.minecraft.smooth_red_sandstone_stairs": "Tropp av jamn raud sandstein",
  "block.minecraft.smooth_sandstone": "Jamn sandstein",
  "block.minecraft.smooth_sandstone_slab": "Hella av jamn sandstein",
  "block.minecraft.smooth_sandstone_stairs": "Tropp av jamn sandstein",
  "block.minecraft.smooth_stone": "Jamn stein",
  "block.minecraft.smooth_stone_slab": "Hella av jamn stein",
  "block.minecraft.sniffer_egg": "Tevaregg",
  "block.minecraft.snow": "Snjo",
  "block.minecraft.snow_block": "Snjoblokk",
  "block.minecraft.soul_campfire": "Sålarbål",
  "block.minecraft.soul_fire": "Sålareld",
  "block.minecraft.soul_lantern": "Sålarlykt",
  "block.minecraft.soul_sand": "Sålarsand",
  "block.minecraft.soul_soil": "Sålarmold",
  "block.minecraft.soul_torch": "Sålarkyndel",
  "block.minecraft.soul_wall_torch": "Veggsålarkyndel",
  "block.minecraft.spawn.not_valid": "Du hev’ ingi seng elder akkjer fyr’ uppstòda, elder so vorto dei stengde",
  "block.minecraft.spawner": "Skræmslekveikjar",
  "block.minecraft.spawner.desc1": "Nytta kveikjeegg:",
  "block.minecraft.spawner.desc2": "Set kvìkendeslag",
  "block.minecraft.sponge": "Svamp",
  "block.minecraft.spore_blossom": "Moseblom",
  "block.minecraft.spruce_button": "Granknapp",
  "block.minecraft.spruce_door": "Grandỳr",
  "block.minecraft.spruce_fence": "Grangard",
  "block.minecraft.spruce_fence_gate": "Grangrind",
  "block.minecraft.spruce_hanging_sign": "Hangande granskilt",
  "block.minecraft.spruce_leaves": "Granbar",
  "block.minecraft.spruce_log": "Granstomn",
  "block.minecraft.spruce_planks": "Granbord",
  "block.minecraft.spruce_pressure_plate": "Gran-tyngdarfjøl",
  "block.minecraft.spruce_sapling": "Granrenning",
  "block.minecraft.spruce_shelf": "Granhylla",
  "block.minecraft.spruce_sign": "Granskilt",
  "block.minecraft.spruce_slab": "Granhella",
  "block.minecraft.spruce_stairs": "Grantropp",
  "block.minecraft.spruce_trapdoor": "Granlem",
  "block.minecraft.spruce_wall_hanging_sign": "Hangande granskilt på vegg",
  "block.minecraft.spruce_wall_sign": "Granveggskilt",
  "block.minecraft.spruce_wood": "Granvìd",
  "block.minecraft.sticky_piston": "Klisterstempel",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Steintiglhella",
  "block.minecraft.stone_brick_stairs": "Steintigltropp",
  "block.minecraft.stone_brick_wall": "Steintiglvegg",
  "block.minecraft.stone_bricks": "Steintigl",
  "block.minecraft.stone_button": "Steinknapp",
  "block.minecraft.stone_pressure_plate": "Stein-tyngdarfjøl",
  "block.minecraft.stone_slab": "Steinhella",
  "block.minecraft.stone_stairs": "Steintropp",
  "block.minecraft.stonecutter": "Steinskjere",
  "block.minecraft.stripped_acacia_log": "Slindad akasiestomn",
  "block.minecraft.stripped_acacia_wood": "Slindad akasievìd",
  "block.minecraft.stripped_bamboo_block": "Slindad bambusblokk",
  "block.minecraft.stripped_birch_log": "Slindad bjørkarstomn",
  "block.minecraft.stripped_birch_wood": "Slindad bjørkarvìd",
  "block.minecraft.stripped_cherry_log": "Slindad kisseberstomn",
  "block.minecraft.stripped_cherry_wood": "Slindad kissebervìd",
  "block.minecraft.stripped_crimson_hyphae": "Slindade blodhyfor",
  "block.minecraft.stripped_crimson_stem": "Slindad blodstomn",
  "block.minecraft.stripped_dark_oak_log": "Slindad myrkeikestomn",
  "block.minecraft.stripped_dark_oak_wood": "Slindad myrkeikevìd",
  "block.minecraft.stripped_jungle_log": "Slindad regnskogsstomn",
  "block.minecraft.stripped_jungle_wood": "Slindad regnskogsvìd",
  "block.minecraft.stripped_mangrove_log": "Slindad mangrovestomn",
  "block.minecraft.stripped_mangrove_wood": "Slindad mangrovevìd",
  "block.minecraft.stripped_oak_log": "Slindad eikestomn",
  "block.minecraft.stripped_oak_wood": "Slindad eikevìd",
  "block.minecraft.stripped_pale_oak_log": "Slindad bleikeikestomn",
  "block.minecraft.stripped_pale_oak_wood": "Slindad bleikeikevìd",
  "block.minecraft.stripped_spruce_log": "Slindad granstomn",
  "block.minecraft.stripped_spruce_wood": "Slindad granvìd",
  "block.minecraft.stripped_warped_hyphae": "Slindade vrìdhyfor",
  "block.minecraft.stripped_warped_stem": "Slindad vrìdstomn",
  "block.minecraft.structure_block": "Bygnadsblokk",
  "block.minecraft.structure_void": "Bygnadstomrom",
  "block.minecraft.sugar_cane": "Sukkerrøyr",
  "block.minecraft.sunflower": "Solvendel",
  "block.minecraft.suspicious_gravel": "Mistenkjeleg aur",
  "block.minecraft.suspicious_sand": "Mistenkjeleg sand",
  "block.minecraft.sweet_berry_bush": "Søtberjalyng",
  "block.minecraft.tall_dry_grass": "Høgt turt gras",
  "block.minecraft.tall_grass": "Høgt gras",
  "block.minecraft.tall_seagrass": "Høgt sjogras",
  "block.minecraft.target": "Skotskiva",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Ryneblokk",
  "block.minecraft.test_instance_block": "Rynehøves-blokk",
  "block.minecraft.tinted_glass": "Svertat glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-sprengnad er avsleget",
  "block.minecraft.torch": "Kyndel",
  "block.minecraft.torchflower": "Kyndelblom",
  "block.minecraft.torchflower_crop": "Kyndelblomgrøda",
  "block.minecraft.trapped_chest": "Fellekista",
  "block.minecraft.trial_spawner": "Røynekveikjar",
  "block.minecraft.tripwire": "Snåvetråd",
  "block.minecraft.tripwire_hook": "Snåvetrådfeste",
  "block.minecraft.tube_coral": "Orgekorall",
  "block.minecraft.tube_coral_block": "Orgekorallblokk",
  "block.minecraft.tube_coral_fan": "Orgekorallveifta",
  "block.minecraft.tube_coral_wall_fan": "Orgekorallveggveifta",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tufftiglhella",
  "block.minecraft.tuff_brick_stairs": "Tufftigltropp",
  "block.minecraft.tuff_brick_wall": "Tufftiglvegg",
  "block.minecraft.tuff_bricks": "Tufftigl",
  "block.minecraft.tuff_slab": "Tuffhella",
  "block.minecraft.tuff_stairs": "Tufftropp",
  "block.minecraft.tuff_wall": "Tuffvegg",
  "block.minecraft.turtle_egg": "Skjelpoddeegg",
  "block.minecraft.twisting_vines": "Krokande klivevokster",
  "block.minecraft.twisting_vines_plant": "Krokande klivevokster",
  "block.minecraft.vault": "Kvelv",
  "block.minecraft.verdant_froglight": "Grønskande froskeljos",
  "block.minecraft.vine": "Klivevokster",
  "block.minecraft.void_air": "Tomromsvind",
  "block.minecraft.wall_torch": "Veggkyndel",
  "block.minecraft.warped_button": "Vrìdknapp",
  "block.minecraft.warped_door": "Vrìddỳr",
  "block.minecraft.warped_fence": "Vrìdgard",
  "block.minecraft.warped_fence_gate": "Vrìdgrind",
  "block.minecraft.warped_fungus": "Vrìdsopp",
  "block.minecraft.warped_hanging_sign": "Hangande vrìdskilt",
  "block.minecraft.warped_hyphae": "Vrìdhyfor",
  "block.minecraft.warped_nylium": "Vrìdsoppvev",
  "block.minecraft.warped_planks": "Vrìdbord",
  "block.minecraft.warped_pressure_plate": "Vrìd-tyngdarfjøl",
  "block.minecraft.warped_roots": "Vrìdrøter",
  "block.minecraft.warped_shelf": "Vrìdhylla",
  "block.minecraft.warped_sign": "Vrìdskilt",
  "block.minecraft.warped_slab": "Vrìdhella",
  "block.minecraft.warped_stairs": "Vrìdtropp",
  "block.minecraft.warped_stem": "Vrìdstomn",
  "block.minecraft.warped_trapdoor": "Vrìdlem",
  "block.minecraft.warped_wall_hanging_sign": "Hangande vrìdskilt på vegg",
  "block.minecraft.warped_wall_sign": "Vrìdveggskilt",
  "block.minecraft.warped_wart_block": "Vrìdvòrteblokk",
  "block.minecraft.water": "Vatn",
  "block.minecraft.water_cauldron": "Vatsgryta",
  "block.minecraft.waxed_chiseled_copper": "Vaksad meitlad kopar",
  "block.minecraft.waxed_copper_bars": "Vaksad kopargrind",
  "block.minecraft.waxed_copper_block": "Vaksad koparblokk",
  "block.minecraft.waxed_copper_bulb": "Vaksad koparpera",
  "block.minecraft.waxed_copper_chain": "Vaksad koparkjedja",
  "block.minecraft.waxed_copper_chest": "Vaksad koparkista",
  "block.minecraft.waxed_copper_door": "Vaksad kopardỳr",
  "block.minecraft.waxed_copper_golem_statue": "Vaksad eirgjengelstytta",
  "block.minecraft.waxed_copper_grate": "Vaksad koparrist",
  "block.minecraft.waxed_copper_lantern": "Vaksad koparlykt",
  "block.minecraft.waxed_copper_trapdoor": "Vaksad koparlem",
  "block.minecraft.waxed_cut_copper": "Vaksad skoren kopar",
  "block.minecraft.waxed_cut_copper_slab": "Vaksad hella av skoren kopar",
  "block.minecraft.waxed_cut_copper_stairs": "Vaksad tropp av skoren kopar",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaksad utsett meitlad kopar",
  "block.minecraft.waxed_exposed_copper": "Vaksad utsett kopar",
  "block.minecraft.waxed_exposed_copper_bars": "Vaksad utsett kopargrind",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaksad utsett koparpera",
  "block.minecraft.waxed_exposed_copper_chain": "Vaksad utsett koparkjedja",
  "block.minecraft.waxed_exposed_copper_chest": "Vaksad utsett koparkista",
  "block.minecraft.waxed_exposed_copper_door": "Vaksad utsett kopardỳr",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaksad utsett eirgjengelstytta",
  "block.minecraft.waxed_exposed_copper_grate": "Vaksad utsett koparrist",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaksad eirad koparlykt",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaksad utsett koparlem",
  "block.minecraft.waxed_exposed_cut_copper": "Vaksad utsett skoren kopar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaksad utsett hella av skoren kopar",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaksad utsett tropp av skoren kopar",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaksad utsett eldingavleidar",
  "block.minecraft.waxed_lightning_rod": "Vaksad eldingavleidar",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaksad eirad meitlad kopar",
  "block.minecraft.waxed_oxidized_copper": "Vaksad eirad kopar",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaksad eirad kopargrind",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaksad eirad koparpera",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaksad eirad koparkjedja",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaksad eirad koparkista",
  "block.minecraft.waxed_oxidized_copper_door": "Vaksad eirad kopardỳr",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaksad eirad eirgjengelstytta",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaksad eirad koparrist",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaksad eirad koparlykt",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaksad eirad koparlem",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaksad eirad skoren kopar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaksad eirad hella av skoren kopar",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaksad eirad tropp av skoren kopar",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaksad eirad eldingavleidar",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaksad vederbiten meitlad kopar",
  "block.minecraft.waxed_weathered_copper": "Vaksad vederbiten kopar",
  "block.minecraft.waxed_weathered_copper_bars": "Vaksad vederbiti kopargrind",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaksad vederbiti koparpera",
  "block.minecraft.waxed_weathered_copper_chain": "Vaksad vederbiti koparkjedja",
  "block.minecraft.waxed_weathered_copper_chest": "Vaksad vederbiti koparkista",
  "block.minecraft.waxed_weathered_copper_door": "Vaksad vederbiti kopardỳr",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaksad vederbiti eirgjengelstytta",
  "block.minecraft.waxed_weathered_copper_grate": "Vaksad vederbiti koparrist",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaksad vederbiti koparlykt",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaksad vederbiten koparlem",
  "block.minecraft.waxed_weathered_cut_copper": "Vaksad vederbiten skoren kopar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaksad vederbiti hella av skoren kopar",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaksad vederbiti tropp av skoren kopar",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaksad vederbiten eldingavleidar",
  "block.minecraft.weathered_chiseled_copper": "Vederbiten meitlad kopar",
  "block.minecraft.weathered_copper": "Vederbiten kopar",
  "block.minecraft.weathered_copper_bars": "Vederbiti kopargrind",
  "block.minecraft.weathered_copper_bulb": "Vederbiti koparpera",
  "block.minecraft.weathered_copper_chain": "Vederbiti koparkjedja",
  "block.minecraft.weathered_copper_chest": "Vederbiti koparkista",
  "block.minecraft.weathered_copper_door": "Vederbiti kopardỳr",
  "block.minecraft.weathered_copper_golem_statue": "Vederbiti eirgjengelstytta",
  "block.minecraft.weathered_copper_grate": "Vederbiti koparrist",
  "block.minecraft.weathered_copper_lantern": "Vederbiti koparlykt",
  "block.minecraft.weathered_copper_trapdoor": "Vêrbiten koparlem",
  "block.minecraft.weathered_cut_copper": "Vederbiten skoren kopar",
  "block.minecraft.weathered_cut_copper_slab": "Vederbiti hella av skoren kopar",
  "block.minecraft.weathered_cut_copper_stairs": "Vederbiti tropp av skoren kopar",
  "block.minecraft.weathered_lightning_rod": "Vederbiten eldingavleidar",
  "block.minecraft.weeping_vines": "Gråtande klivevokster",
  "block.minecraft.weeping_vines_plant": "Gråtande klivevokster",
  "block.minecraft.wet_sponge": "Blaut svamp",
  "block.minecraft.wheat": "Kveitegrøda",
  "block.minecraft.white_banner": "Kvit fana",
  "block.minecraft.white_bed": "Kvit seng",
  "block.minecraft.white_candle": "Kvitt vaksljos",
  "block.minecraft.white_candle_cake": "Kaka med kvitt vaksljos",
  "block.minecraft.white_carpet": "Kvit rya",
  "block.minecraft.white_concrete": "Kvit støypestein",
  "block.minecraft.white_concrete_powder": "Kvit støypesteinsdumba",
  "block.minecraft.white_glazed_terracotta": "Kvit glasad terrakotta",
  "block.minecraft.white_shulker_box": "Kvitt shulkerhus",
  "block.minecraft.white_stained_glass": "Kvitlìtat glas",
  "block.minecraft.white_stained_glass_pane": "Kvitlìtad glasruta",
  "block.minecraft.white_terracotta": "Kvit terrakotta",
  "block.minecraft.white_tulip": "Kvit tulipan",
  "block.minecraft.white_wool": "Kvit ull",
  "block.minecraft.wildflowers": "Markblomar",
  "block.minecraft.wither_rose": "Witherrosa",
  "block.minecraft.wither_skeleton_skull": "Witherskalle",
  "block.minecraft.wither_skeleton_wall_skull": "Witherveggskalle",
  "block.minecraft.yellow_banner": "Gul fana",
  "block.minecraft.yellow_bed": "Gul seng",
  "block.minecraft.yellow_candle": "Gult vaksljos",
  "block.minecraft.yellow_candle_cake": "Kaka med gult vaksljos",
  "block.minecraft.yellow_carpet": "Gul rya",
  "block.minecraft.yellow_concrete": "Gul støypestein",
  "block.minecraft.yellow_concrete_powder": "Gul støypesteinsdumba",
  "block.minecraft.yellow_glazed_terracotta": "Gul glasad terrakotta",
  "block.minecraft.yellow_shulker_box": "Gult shulkerhus",
  "block.minecraft.yellow_stained_glass": "Gullìtat glas",
  "block.minecraft.yellow_stained_glass_pane": "Gullìtad glasruta",
  "block.minecraft.yellow_terracotta": "Gul terrakotta",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Nåehovud",
  "block.minecraft.zombie_wall_head": "Nåevegghovud",
  "item.minecraft.acacia_boat": "Akasiebåt",
  "item.minecraft.acacia_chest_boat": "Akasiebåt med kista",
  "item.minecraft.allay_spawn_egg": "Kveikjeegg fyre hjelpeònd",
  "item.minecraft.amethyst_shard": "Ametystbrot",
  "item.minecraft.angler_pottery_shard": "Skålbrot med fiskestong",
  "item.minecraft.angler_pottery_sherd": "Skålbrot med fiskestong",
  "item.minecraft.apple": "Eple",
  "item.minecraft.archer_pottery_shard": "Skålbrot med bogeskyttar",
  "item.minecraft.archer_pottery_sherd": "Skålbrot med bogeskyttar",
  "item.minecraft.armadillo_scute": "Beltedyrskjold",
  "item.minecraft.armadillo_spawn_egg": "Kveikjeegg fyre beltedyr",
  "item.minecraft.armor_stand": "Brynjestod",
  "item.minecraft.arms_up_pottery_shard": "Skålbrot med armar i vedret",
  "item.minecraft.arms_up_pottery_sherd": "Skålbrot med armar i vedret",
  "item.minecraft.arrow": "Kolv",
  "item.minecraft.axolotl_bucket": "Spann med aksolotl",
  "item.minecraft.axolotl_spawn_egg": "Kveikjeegg fyr’ aksolotl",
  "item.minecraft.baked_potato": "Bakat jordeple",
  "item.minecraft.bamboo_chest_raft": "Bambusflòte med kista",
  "item.minecraft.bamboo_raft": "Bambusflòte",
  "item.minecraft.bat_spawn_egg": "Kveikjeegg fyre skjåvengja",
  "item.minecraft.bee_spawn_egg": "Kveikjeegg fyre bia",
  "item.minecraft.beef": "Rått uksekjøt",
  "item.minecraft.beetroot": "Raudbeta",
  "item.minecraft.beetroot_seeds": "Raudbetefrjo",
  "item.minecraft.beetroot_soup": "Raudbetesupa",
  "item.minecraft.birch_boat": "Bjørkarbåt",
  "item.minecraft.birch_chest_boat": "Bjørkarbåt med kista",
  "item.minecraft.black_bundle": "Svart sekk",
  "item.minecraft.black_dye": "Svart lìtemne",
  "item.minecraft.black_harness": "Svart selety",
  "item.minecraft.blade_pottery_shard": "Skålbrot med sverd",
  "item.minecraft.blade_pottery_sherd": "Skålbrot med sverd",
  "item.minecraft.blaze_powder": "Logedumba",
  "item.minecraft.blaze_rod": "Logestav",
  "item.minecraft.blaze_spawn_egg": "Kveikjeegg fyre loge",
  "item.minecraft.blue_bundle": "Blå sekk",
  "item.minecraft.blue_dye": "Blått lìtemne",
  "item.minecraft.blue_egg": "Blått egg",
  "item.minecraft.blue_harness": "Blått selety",
  "item.minecraft.bogged_spawn_egg": "Kveikjeegg fyre myrgrind",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt-brynjepryd",
  "item.minecraft.bone": "Bein",
  "item.minecraft.bone_meal": "Beinmjøl",
  "item.minecraft.book": "Bok",
  "item.minecraft.bordure_indented_banner_pattern": "Fanemynster fyre bord",
  "item.minecraft.bow": "Boge",
  "item.minecraft.bowl": "Skål",
  "item.minecraft.bread": "Braud",
  "item.minecraft.breeze_rod": "Flogestav",
  "item.minecraft.breeze_spawn_egg": "Kveikjeegg fyre floga",
  "item.minecraft.brewer_pottery_shard": "Skålbrot med brygg",
  "item.minecraft.brewer_pottery_sherd": "Skålbrot med brygg",
  "item.minecraft.brewing_stand": "Bryggjereidskap",
  "item.minecraft.brick": "Tigl",
  "item.minecraft.brown_bundle": "Brun sekk",
  "item.minecraft.brown_dye": "Brunt lìtemne",
  "item.minecraft.brown_egg": "Brunt egg",
  "item.minecraft.brown_harness": "Brunt selety",
  "item.minecraft.brush": "Kost",
  "item.minecraft.bucket": "Spann",
  "item.minecraft.bundle": "Sekk",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kann halda eit blandat lad av ting",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Skålbrot med eldtunga",
  "item.minecraft.burn_pottery_sherd": "Skålbrot med eldtunga",
  "item.minecraft.camel_husk_spawn_egg": "Kveikjeegg fyr’ ulvaldeskolm",
  "item.minecraft.camel_spawn_egg": "Kveikjeegg fyr’ ulvalde",
  "item.minecraft.carrot": "Gulrot",
  "item.minecraft.carrot_on_a_stick": "Gulrot på stong",
  "item.minecraft.cat_spawn_egg": "Kveikjeegg fyre katt",
  "item.minecraft.cauldron": "Gryta",
  "item.minecraft.cave_spider_spawn_egg": "Kveikjeegg fyr’ hòlekongurvåva",
  "item.minecraft.chainmail_boots": "Ringbrynjeskor",
  "item.minecraft.chainmail_chestplate": "Ringbrynja",
  "item.minecraft.chainmail_helmet": "Ringbrynjehetta",
  "item.minecraft.chainmail_leggings": "Ringbrynjehòsa",
  "item.minecraft.charcoal": "Trekol",
  "item.minecraft.cherry_boat": "Kisseberbåt",
  "item.minecraft.cherry_chest_boat": "Kisseberbåt med kista",
  "item.minecraft.chest_minecart": "Malmvogn med kista",
  "item.minecraft.chicken": "Rått hønsekjøt",
  "item.minecraft.chicken_spawn_egg": "Kveikjeegg fyr’ høna",
  "item.minecraft.chorus_fruit": "Koralda",
  "item.minecraft.clay_ball": "Leirball",
  "item.minecraft.clock": "Klokka",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Strand-brynjepryd",
  "item.minecraft.cocoa_beans": "Kakaobaunor",
  "item.minecraft.cod": "Rå torsk",
  "item.minecraft.cod_bucket": "Torskespann",
  "item.minecraft.cod_spawn_egg": "Kveikjeegg fyre torsk",
  "item.minecraft.command_block_minecart": "Malmvogn med styrebòdsblokk",
  "item.minecraft.compass": "Kompås",
  "item.minecraft.cooked_beef": "Uksesteik",
  "item.minecraft.cooked_chicken": "Steikt høna",
  "item.minecraft.cooked_cod": "Steikt torsk",
  "item.minecraft.cooked_mutton": "Saudesteik",
  "item.minecraft.cooked_porkchop": "Svinesteik",
  "item.minecraft.cooked_rabbit": "Steikt harekjøt",
  "item.minecraft.cooked_salmon": "Steikt laks",
  "item.minecraft.cookie": "Kjeks",
  "item.minecraft.copper_axe": "Koparøks",
  "item.minecraft.copper_boots": "Koparstyvlar",
  "item.minecraft.copper_chestplate": "Koparbrynja",
  "item.minecraft.copper_golem_spawn_egg": "Kveikjeegg fyre eirgjengel",
  "item.minecraft.copper_helmet": "Koparhjelm",
  "item.minecraft.copper_hoe": "Kopargrev",
  "item.minecraft.copper_horse_armor": "Koparbrynja til øyk",
  "item.minecraft.copper_ingot": "Koparstykke",
  "item.minecraft.copper_leggings": "Koparbrok",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Koparklump",
  "item.minecraft.copper_pickaxe": "Koparhakka",
  "item.minecraft.copper_shovel": "Koparspade",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Koparsverd",
  "item.minecraft.cow_spawn_egg": "Kveikjeegg fyre naut",
  "item.minecraft.creaking_spawn_egg": "Kveikjeegg fyre knerk",
  "item.minecraft.creeper_banner_pattern": "Fanemynster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Fanemynster fyre creeper",
  "item.minecraft.creeper_spawn_egg": "Kveikjeegg fyre creeper",
  "item.minecraft.crossbow": "Låsboge",
  "item.minecraft.crossbow.projectile": "Skot:",
  "item.minecraft.crossbow.projectile.multiple": "Skot: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Skot: %s",
  "item.minecraft.cyan_bundle": "Blågrøn sekk",
  "item.minecraft.cyan_dye": "Blågrønt lìtemne",
  "item.minecraft.cyan_harness": "Blågrønt selety",
  "item.minecraft.danger_pottery_shard": "Skålbrot med creeper",
  "item.minecraft.danger_pottery_sherd": "Skålbrot med creeper",
  "item.minecraft.dark_oak_boat": "Myrkeikebåt",
  "item.minecraft.dark_oak_chest_boat": "Myrkeikebåt med kista",
  "item.minecraft.debug_stick": "Lyskepinne",
  "item.minecraft.debug_stick.empty": "%s hev’ ingi gjerder",
  "item.minecraft.debug_stick.select": "valde «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» til %s",
  "item.minecraft.diamond": "Demant",
  "item.minecraft.diamond_axe": "Demantøks",
  "item.minecraft.diamond_boots": "Demantstyvlar",
  "item.minecraft.diamond_chestplate": "Demantbrynja",
  "item.minecraft.diamond_helmet": "Demanthjelm",
  "item.minecraft.diamond_hoe": "Demantgrev",
  "item.minecraft.diamond_horse_armor": "Demantbrynja til øyk",
  "item.minecraft.diamond_leggings": "Demantbrok",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Demanthakka",
  "item.minecraft.diamond_shovel": "Demantspade",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Demantsverd",
  "item.minecraft.disc_fragment_5": "Skivebrot",
  "item.minecraft.disc_fragment_5.desc": "Skiva – 5",
  "item.minecraft.dolphin_spawn_egg": "Kveikjeegg fyre tumlar",
  "item.minecraft.donkey_spawn_egg": "Kveikjeegg fyr’ asne",
  "item.minecraft.dragon_breath": "Drakeande",
  "item.minecraft.dried_kelp": "Turkad tare",
  "item.minecraft.drowned_spawn_egg": "Kveikjeegg fyre sjodraug",
  "item.minecraft.dune_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Sandheid-brynjepryd",
  "item.minecraft.echo_shard": "Atterljomsbrot",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Kveikjeegg fyr’ eldre verjar",
  "item.minecraft.elytra": "Skalvenger",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Runebok",
  "item.minecraft.enchanted_golden_apple": "Trollbundet gulleple",
  "item.minecraft.end_crystal": "Endedvergsmide",
  "item.minecraft.ender_dragon_spawn_egg": "Kveikjeegg fyr’ enderdrake",
  "item.minecraft.ender_eye": "Enderauga",
  "item.minecraft.ender_pearl": "Enderperla",
  "item.minecraft.enderman_spawn_egg": "Kveikjeegg fyr’ endermann",
  "item.minecraft.endermite_spawn_egg": "Kveikjeegg fyr’ endermit",
  "item.minecraft.evoker_spawn_egg": "Kveikjeegg fyr’ andevekkjar",
  "item.minecraft.experience_bottle": "Galdreflaska",
  "item.minecraft.explorer_pottery_shard": "Skålbrot med kort",
  "item.minecraft.explorer_pottery_sherd": "Skålbrot med kort",
  "item.minecraft.eye_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Auge-brynjepryd",
  "item.minecraft.feather": "Fjøder",
  "item.minecraft.fermented_spider_eye": "Aset auga av kongurvåva",
  "item.minecraft.field_masoned_banner_pattern": "Fanemynster fyre tigl",
  "item.minecraft.filled_map": "Kort",
  "item.minecraft.fire_charge": "Eldlading",
  "item.minecraft.firework_rocket": "Fyrverk",
  "item.minecraft.firework_rocket.flight": "Flogtid:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrverksstjørna",
  "item.minecraft.firework_star.black": "Svòrt",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Tilmåtad",
  "item.minecraft.firework_star.cyan": "Blågrøn",
  "item.minecraft.firework_star.fade_to": "Fåna til",
  "item.minecraft.firework_star.flicker": "Gnistring",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Grøn",
  "item.minecraft.firework_star.light_blue": "Ljosblå",
  "item.minecraft.firework_star.light_gray": "Ljosgrå",
  "item.minecraft.firework_star.lime": "Ljosgrøn",
  "item.minecraft.firework_star.magenta": "Ljosblåraud",
  "item.minecraft.firework_star.orange": "Brandgul",
  "item.minecraft.firework_star.pink": "Ljosraud",
  "item.minecraft.firework_star.purple": "Blåraud",
  "item.minecraft.firework_star.red": "Raud",
  "item.minecraft.firework_star.shape": "Ukjend form",
  "item.minecraft.firework_star.shape.burst": "Sprengjing",
  "item.minecraft.firework_star.shape.creeper": "Creeperformad",
  "item.minecraft.firework_star.shape.large_ball": "Stor kula",
  "item.minecraft.firework_star.shape.small_ball": "Liti kula",
  "item.minecraft.firework_star.shape.star": "Stjørneformad",
  "item.minecraft.firework_star.trail": "Spòr",
  "item.minecraft.firework_star.white": "Kvit",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Fiskestong",
  "item.minecraft.flint": "Tinna",
  "item.minecraft.flint_and_steel": "Eldjarn",
  "item.minecraft.flow_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Kvervel-brynjepryd",
  "item.minecraft.flow_banner_pattern": "Fanemynster",
  "item.minecraft.flow_banner_pattern.desc": "Kvervel",
  "item.minecraft.flow_banner_pattern.new": "Fanemynster fyre kvervel",
  "item.minecraft.flow_pottery_sherd": "Skålbrot med kvervel",
  "item.minecraft.flower_banner_pattern": "Fanemynster",
  "item.minecraft.flower_banner_pattern.desc": "Blom",
  "item.minecraft.flower_banner_pattern.new": "Fanemynster fyre blom",
  "item.minecraft.flower_pot": "Blompotta",
  "item.minecraft.fox_spawn_egg": "Kveikjeegg fyre rev",
  "item.minecraft.friend_pottery_shard": "Skålbrot med vìnsamt andlìt",
  "item.minecraft.friend_pottery_sherd": "Skålbrot med vìnsamt andlìt",
  "item.minecraft.frog_spawn_egg": "Kveikjeegg fyre frosk",
  "item.minecraft.furnace_minecart": "Malmvogn med omn",
  "item.minecraft.ghast_spawn_egg": "Kveikjeegg fyre ghast",
  "item.minecraft.ghast_tear": "Ghasttår",
  "item.minecraft.glass_bottle": "Glasflaska",
  "item.minecraft.glistering_melon_slice": "Glitrande melonbåt",
  "item.minecraft.globe_banner_pattern": "Fanemynster",
  "item.minecraft.globe_banner_pattern.desc": "Klote",
  "item.minecraft.globe_banner_pattern.new": "Fanemynster fyre klote",
  "item.minecraft.glow_berries": "Glødeber",
  "item.minecraft.glow_ink_sac": "Glødeblèksekk",
  "item.minecraft.glow_item_frame": "Glødande råma",
  "item.minecraft.glow_squid_spawn_egg": "Kveikjeegg fyre glødespruta",
  "item.minecraft.glowstone_dust": "Glødesteinsdumba",
  "item.minecraft.goat_horn": "Bukkehorn",
  "item.minecraft.goat_spawn_egg": "Kveikjeegg fyre geit",
  "item.minecraft.gold_ingot": "Gullstykke",
  "item.minecraft.gold_nugget": "Gullklump",
  "item.minecraft.golden_apple": "Gulleple",
  "item.minecraft.golden_axe": "Gulløks",
  "item.minecraft.golden_boots": "Gullstyvlar",
  "item.minecraft.golden_carrot": "Gullrot",
  "item.minecraft.golden_chestplate": "Gullbrynja",
  "item.minecraft.golden_helmet": "Gullhjelm",
  "item.minecraft.golden_hoe": "Gullgrev",
  "item.minecraft.golden_horse_armor": "Gullbrynja til øyk",
  "item.minecraft.golden_leggings": "Gullbrok",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Gullhakka",
  "item.minecraft.golden_shovel": "Gullspade",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Gullsverd",
  "item.minecraft.gray_bundle": "Grå sekk",
  "item.minecraft.gray_dye": "Grått lìtemne",
  "item.minecraft.gray_harness": "Grått selety",
  "item.minecraft.green_bundle": "Grøn sekk",
  "item.minecraft.green_dye": "Grønt lìtemne",
  "item.minecraft.green_harness": "Grønt selety",
  "item.minecraft.guardian_spawn_egg": "Kveikjeegg fyre verjar",
  "item.minecraft.gunpowder": "Krut",
  "item.minecraft.guster_banner_pattern": "Fanemynster",
  "item.minecraft.guster_banner_pattern.desc": "Floga",
  "item.minecraft.guster_banner_pattern.new": "Fanemynster fyre floga",
  "item.minecraft.guster_pottery_sherd": "Skålbrot med floga",
  "item.minecraft.happy_ghast_spawn_egg": "Kveikjeegg fyre gladvært ghast",
  "item.minecraft.harness": "Selety",
  "item.minecraft.heart_of_the_sea": "Hjarta åt havet",
  "item.minecraft.heart_pottery_shard": "Skålbrot med hjarta",
  "item.minecraft.heart_pottery_sherd": "Skålbrot med hjarta",
  "item.minecraft.heartbreak_pottery_shard": "Skålbrot med brotet hjarta",
  "item.minecraft.heartbreak_pottery_sherd": "Skålbrot med brotet hjarta",
  "item.minecraft.hoglin_spawn_egg": "Kveikjeegg fyr’ hoglin",
  "item.minecraft.honey_bottle": "Huningflaska",
  "item.minecraft.honeycomb": "Vakskaka",
  "item.minecraft.hopper_minecart": "Malmvogn med trekt",
  "item.minecraft.horse_spawn_egg": "Kveikjeegg fyr’ øyk",
  "item.minecraft.host_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.host_armor_trim_smithing_template.new": "Hysar-brynjepryd",
  "item.minecraft.howl_pottery_shard": "Skålbrot med ulv",
  "item.minecraft.howl_pottery_sherd": "Skålbrot med ulv",
  "item.minecraft.husk_spawn_egg": "Kveikjeegg fyre skolm",
  "item.minecraft.ink_sac": "Blèksekk",
  "item.minecraft.iron_axe": "Jarnøks",
  "item.minecraft.iron_boots": "Jarnstyvlar",
  "item.minecraft.iron_chestplate": "Jarnbrynja",
  "item.minecraft.iron_golem_spawn_egg": "Kveikjeegg fyre jarnkall",
  "item.minecraft.iron_helmet": "Jarnhjelm",
  "item.minecraft.iron_hoe": "Jarngrev",
  "item.minecraft.iron_horse_armor": "Jarnbrynja til øyk",
  "item.minecraft.iron_ingot": "Jarnstykke",
  "item.minecraft.iron_leggings": "Jarnbrok",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Jarnklump",
  "item.minecraft.iron_pickaxe": "Jarnhakka",
  "item.minecraft.iron_shovel": "Jarnspade",
  "item.minecraft.iron_spear": "Jarnspjot",
  "item.minecraft.iron_sword": "Jarnsverd",
  "item.minecraft.item_frame": "Råma",
  "item.minecraft.jungle_boat": "Regnskogsbåt",
  "item.minecraft.jungle_chest_boat": "Regnskogsbåt med kista",
  "item.minecraft.knowledge_book": "Kunnebok",
  "item.minecraft.lapis_lazuli": "Lasurstein",
  "item.minecraft.lava_bucket": "Raunspann",
  "item.minecraft.lead": "Band",
  "item.minecraft.leather": "Leder",
  "item.minecraft.leather_boots": "Lederstyvlar",
  "item.minecraft.leather_chestplate": "Ledertrøya",
  "item.minecraft.leather_helmet": "Lederhuva",
  "item.minecraft.leather_horse_armor": "Lederbrynja til øyk",
  "item.minecraft.leather_leggings": "Lederbrok",
  "item.minecraft.light_blue_bundle": "Ljosblå sekk",
  "item.minecraft.light_blue_dye": "Ljosblått lìtemne",
  "item.minecraft.light_blue_harness": "Ljosblått selety",
  "item.minecraft.light_gray_bundle": "Ljosgrå sekk",
  "item.minecraft.light_gray_dye": "Ljosgrått lìtemne",
  "item.minecraft.light_gray_harness": "Ljosgrått selety",
  "item.minecraft.lime_bundle": "Ljosgrøn sekk",
  "item.minecraft.lime_dye": "Ljosgrønt lìtemne",
  "item.minecraft.lime_harness": "Ljosgrønt selety",
  "item.minecraft.lingering_potion": "Dveljebrygg",
  "item.minecraft.lingering_potion.effect.awkward": "Keivelegt dveljande brygg",
  "item.minecraft.lingering_potion.effect.empty": "Dveljande inkje-emnande brygg",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dveljande eldvernsbrygg",
  "item.minecraft.lingering_potion.effect.harming": "Dveljande skadebrygg",
  "item.minecraft.lingering_potion.effect.healing": "Dveljande lækjebrygg",
  "item.minecraft.lingering_potion.effect.infested": "Dveljande fengjebrygg",
  "item.minecraft.lingering_potion.effect.invisibility": "Dveljande usynleikebrygg",
  "item.minecraft.lingering_potion.effect.leaping": "Dveljande byksebrygg",
  "item.minecraft.lingering_potion.effect.levitation": "Dveljande svivebrygg",
  "item.minecraft.lingering_potion.effect.luck": "Dveljande heppebrygg",
  "item.minecraft.lingering_potion.effect.mundane": "Kvardagslegt dveljande brygg",
  "item.minecraft.lingering_potion.effect.night_vision": "Dveljande nattarsynsbrygg",
  "item.minecraft.lingering_potion.effect.oozing": "Dveljande tytebrygg",
  "item.minecraft.lingering_potion.effect.poison": "Dveljande eiterbrygg",
  "item.minecraft.lingering_potion.effect.regeneration": "Dveljande atterskapebrygg",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dveljande seinfallsbrygg",
  "item.minecraft.lingering_potion.effect.slowness": "Dveljande tråleikebrygg",
  "item.minecraft.lingering_potion.effect.strength": "Dveljande styrkjebrygg",
  "item.minecraft.lingering_potion.effect.swiftness": "Dveljande Snarleikebrygg",
  "item.minecraft.lingering_potion.effect.thick": "Dveljande tjukt brygg",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dveljebrygg frå skjelpoddemeistaren",
  "item.minecraft.lingering_potion.effect.water": "Dveljande vatsflaska",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dveljande vatsandebrygg",
  "item.minecraft.lingering_potion.effect.weakness": "Dveljande veikjebrygg",
  "item.minecraft.lingering_potion.effect.weaving": "Dveljande vevebrygg",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dveljande vindladingbrygg",
  "item.minecraft.llama_spawn_egg": "Kveikjeegg fyre lama",
  "item.minecraft.lodestone_compass": "Kompås fyre leidarstein",
  "item.minecraft.mace": "Stridsklubba",
  "item.minecraft.magenta_bundle": "Ljosblåraud sekk",
  "item.minecraft.magenta_dye": "Ljosblåraudt lìtemne",
  "item.minecraft.magenta_harness": "Ljosblåraudt selety",
  "item.minecraft.magma_cream": "Raunsmyrja",
  "item.minecraft.magma_cube_spawn_egg": "Kveikjeegg fyre raunkubb",
  "item.minecraft.mangrove_boat": "Mangrovebåt",
  "item.minecraft.mangrove_chest_boat": "Mangrovebåt med kista",
  "item.minecraft.map": "Tomt kort",
  "item.minecraft.melon_seeds": "Melonfrjo",
  "item.minecraft.melon_slice": "Melonbåt",
  "item.minecraft.milk_bucket": "Mjølkespann",
  "item.minecraft.minecart": "Malmvogn",
  "item.minecraft.miner_pottery_shard": "Skålbrot med hakka",
  "item.minecraft.miner_pottery_sherd": "Skålbrot med hakka",
  "item.minecraft.mojang_banner_pattern": "Fanemynster",
  "item.minecraft.mojang_banner_pattern.desc": "Ting",
  "item.minecraft.mojang_banner_pattern.new": "Fanemynster fyre ting",
  "item.minecraft.mooshroom_spawn_egg": "Kveikjeegg fyre mooshroom",
  "item.minecraft.mourner_pottery_shard": "Skålbrot med syrgjande",
  "item.minecraft.mourner_pottery_sherd": "Skålbrot med syrgjande",
  "item.minecraft.mule_spawn_egg": "Kveikjeegg fyre muldyr",
  "item.minecraft.mushroom_stew": "Soppgryta",
  "item.minecraft.music_disc_11": "Skiva",
  "item.minecraft.music_disc_11.desc": "C418 – 11",
  "item.minecraft.music_disc_13": "Skiva",
  "item.minecraft.music_disc_13.desc": "C418 – 13",
  "item.minecraft.music_disc_5": "Skiva",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Skiva",
  "item.minecraft.music_disc_blocks.desc": "C418 – blocks",
  "item.minecraft.music_disc_cat": "Skiva",
  "item.minecraft.music_disc_cat.desc": "C418 – cat",
  "item.minecraft.music_disc_chirp": "Skiva",
  "item.minecraft.music_disc_chirp.desc": "C418 – chirp",
  "item.minecraft.music_disc_creator": "Skiva",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Skiva",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (speldåsa)",
  "item.minecraft.music_disc_far": "Skiva",
  "item.minecraft.music_disc_far.desc": "C418 – far",
  "item.minecraft.music_disc_lava_chicken": "Skiva",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Skiva",
  "item.minecraft.music_disc_mall.desc": "C418 – mall",
  "item.minecraft.music_disc_mellohi": "Skiva",
  "item.minecraft.music_disc_mellohi.desc": "C418 – mellohi",
  "item.minecraft.music_disc_otherside": "Skiva",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Skiva",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Skiva",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Skiva",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Skiva",
  "item.minecraft.music_disc_stal.desc": "C418 – stal",
  "item.minecraft.music_disc_strad": "Skiva",
  "item.minecraft.music_disc_strad.desc": "C418 – strad",
  "item.minecraft.music_disc_tears": "Skiva",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Skiva",
  "item.minecraft.music_disc_wait.desc": "C418 – wait",
  "item.minecraft.music_disc_ward": "Skiva",
  "item.minecraft.music_disc_ward.desc": "C418 – ward",
  "item.minecraft.mutton": "Rått saudekjøt",
  "item.minecraft.name_tag": "Namneskilt",
  "item.minecraft.nautilus_shell": "Perlebåtkuvung",
  "item.minecraft.nautilus_spawn_egg": "Kveikjeegg fyre perlebåt",
  "item.minecraft.nether_brick": "Nethertigl",
  "item.minecraft.nether_star": "Netherstjørna",
  "item.minecraft.nether_wart": "Nethervòrta",
  "item.minecraft.netherite_axe": "Netherittøks",
  "item.minecraft.netherite_boots": "Netherittstyvlar",
  "item.minecraft.netherite_chestplate": "Netherittbrynja",
  "item.minecraft.netherite_helmet": "Netheritthjelm",
  "item.minecraft.netherite_hoe": "Netherittgrev",
  "item.minecraft.netherite_horse_armor": "Netherittbrynja til øyk",
  "item.minecraft.netherite_ingot": "Netherittstykke",
  "item.minecraft.netherite_leggings": "Netherittbrok",
  "item.minecraft.netherite_nautilus_armor": "Perlebåtbrynja av netheritt",
  "item.minecraft.netherite_pickaxe": "Netheritthakka",
  "item.minecraft.netherite_scrap": "Netherittskrap",
  "item.minecraft.netherite_shovel": "Netherittspade",
  "item.minecraft.netherite_spear": "Netherittspjot",
  "item.minecraft.netherite_sword": "Netherittsverd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smideskant",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherittbetring",
  "item.minecraft.oak_boat": "Eikebåt",
  "item.minecraft.oak_chest_boat": "Eikebåt med kista",
  "item.minecraft.ocelot_spawn_egg": "Kveikjeegg fyr’ ocelott",
  "item.minecraft.ominous_bottle": "Illspåi flaska",
  "item.minecraft.ominous_trial_key": "Illspåen røynelykel",
  "item.minecraft.orange_bundle": "Brandgul sekk",
  "item.minecraft.orange_dye": "Brandgult lìtemne",
  "item.minecraft.orange_harness": "Brandgult selety",
  "item.minecraft.painting": "Målarstykke",
  "item.minecraft.pale_oak_boat": "Bleikeikebåt",
  "item.minecraft.pale_oak_chest_boat": "Bleikeikebåt med kista",
  "item.minecraft.panda_spawn_egg": "Kveikjeegg fyre pandabjørn",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Kveikjeegg fyre tỳrke",
  "item.minecraft.parrot_spawn_egg": "Kveikjeegg fyre pavegauk",
  "item.minecraft.phantom_membrane": "Tankefosterskjå",
  "item.minecraft.phantom_spawn_egg": "Kveikjeegg fyre tankefoster",
  "item.minecraft.pig_spawn_egg": "Kveikjeegg fyre svin",
  "item.minecraft.piglin_banner_pattern": "Fanemynster",
  "item.minecraft.piglin_banner_pattern.desc": "Tryne",
  "item.minecraft.piglin_banner_pattern.new": "Fanemynster fyre tryne",
  "item.minecraft.piglin_brute_spawn_egg": "Kveikjeegg fyre piglinråskinn",
  "item.minecraft.piglin_spawn_egg": "Kveikjeegg fyre piglin",
  "item.minecraft.pillager_spawn_egg": "Kveikjeegg fyre ransbue",
  "item.minecraft.pink_bundle": "Ljosraud sekk",
  "item.minecraft.pink_dye": "Ljosraudt lìtemne",
  "item.minecraft.pink_harness": "Ljosraudt selety",
  "item.minecraft.pitcher_plant": "Kannerot",
  "item.minecraft.pitcher_pod": "Kannefrjo",
  "item.minecraft.plenty_pottery_shard": "Skålbrot med kista",
  "item.minecraft.plenty_pottery_sherd": "Skålbrot med kista",
  "item.minecraft.poisonous_potato": "Eitrugt jordeple",
  "item.minecraft.polar_bear_spawn_egg": "Kveikjeegg fyre kvitebjørn",
  "item.minecraft.popped_chorus_fruit": "Sprungi koralda",
  "item.minecraft.porkchop": "Rått svinekjøt",
  "item.minecraft.potato": "Jordeple",
  "item.minecraft.potion": "Brygg",
  "item.minecraft.potion.effect.awkward": "Keivelegt brygg",
  "item.minecraft.potion.effect.empty": "Inkje-emnande brygg",
  "item.minecraft.potion.effect.fire_resistance": "Eldvernsbrygg",
  "item.minecraft.potion.effect.harming": "Skadebrygg",
  "item.minecraft.potion.effect.healing": "Lækjebrygg",
  "item.minecraft.potion.effect.infested": "Fengjebrygg",
  "item.minecraft.potion.effect.invisibility": "Usynleikebrygg",
  "item.minecraft.potion.effect.leaping": "Byksebrygg",
  "item.minecraft.potion.effect.levitation": "Svivebrygg",
  "item.minecraft.potion.effect.luck": "Heppebrygg",
  "item.minecraft.potion.effect.mundane": "Kvardagslegt brygg",
  "item.minecraft.potion.effect.night_vision": "Nattarsynsbrygg",
  "item.minecraft.potion.effect.oozing": "Tytebrygg",
  "item.minecraft.potion.effect.poison": "Eiterbrygg",
  "item.minecraft.potion.effect.regeneration": "Atterskapebrygg",
  "item.minecraft.potion.effect.slow_falling": "Seinfallsbrygg",
  "item.minecraft.potion.effect.slowness": "Tråleikebrygg",
  "item.minecraft.potion.effect.strength": "Styrkjebrygg",
  "item.minecraft.potion.effect.swiftness": "Snarleikebrygg",
  "item.minecraft.potion.effect.thick": "Tjukt brygg",
  "item.minecraft.potion.effect.turtle_master": "Brygg frå skjelpoddemeistaren",
  "item.minecraft.potion.effect.water": "Vatsflaska",
  "item.minecraft.potion.effect.water_breathing": "Vatsandebrygg",
  "item.minecraft.potion.effect.weakness": "Veikjebrygg",
  "item.minecraft.potion.effect.weaving": "Vevebrygg",
  "item.minecraft.potion.effect.wind_charged": "Vindladebrygg",
  "item.minecraft.pottery_shard_archer": "Skålbrot med bogeskyttar",
  "item.minecraft.pottery_shard_arms_up": "Skålbrot med armar i vedret",
  "item.minecraft.pottery_shard_prize": "Skålbrot med glimestein",
  "item.minecraft.pottery_shard_skull": "Skålbrot med skalle",
  "item.minecraft.powder_snow_bucket": "Mjøllspann",
  "item.minecraft.prismarine_crystals": "Prismarindvergsmide",
  "item.minecraft.prismarine_shard": "Prismarinbrot",
  "item.minecraft.prize_pottery_shard": "Skålbrot med glimestein",
  "item.minecraft.prize_pottery_sherd": "Skålbrot med glimestein",
  "item.minecraft.pufferfish": "Igulfisk",
  "item.minecraft.pufferfish_bucket": "Spann med igulfisk",
  "item.minecraft.pufferfish_spawn_egg": "Kveikjeegg fyre igulfisk",
  "item.minecraft.pumpkin_pie": "Graskjerpai",
  "item.minecraft.pumpkin_seeds": "Graskjerfrjo",
  "item.minecraft.purple_bundle": "Blåraud sekk",
  "item.minecraft.purple_dye": "Blåraudt lìtemne",
  "item.minecraft.purple_harness": "Blåraudt selety",
  "item.minecraft.quartz": "Netherkattstein",
  "item.minecraft.rabbit": "Rått hjasekjøt",
  "item.minecraft.rabbit_foot": "Hjaselabb",
  "item.minecraft.rabbit_hide": "Hjasefell",
  "item.minecraft.rabbit_spawn_egg": "Kveikjeegg fyre hjase",
  "item.minecraft.rabbit_stew": "Hjasegryta",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Lyftar-brynjepryd",
  "item.minecraft.ravager_spawn_egg": "Kveikjeegg fyr’ herjar",
  "item.minecraft.raw_copper": "Råkopar",
  "item.minecraft.raw_gold": "Rågull",
  "item.minecraft.raw_iron": "Råjarn",
  "item.minecraft.recovery_compass": "Kompås til atterfinning",
  "item.minecraft.red_bundle": "Raud sekk",
  "item.minecraft.red_dye": "Raudt lìtemne",
  "item.minecraft.red_harness": "Raudt selety",
  "item.minecraft.redstone": "Redstonedumba",
  "item.minecraft.resin_brick": "Kvådetigl",
  "item.minecraft.resin_clump": "Kvådeklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rivbeins-brynjepryd",
  "item.minecraft.rotten_flesh": "Ròte kjøt",
  "item.minecraft.saddle": "Sadel",
  "item.minecraft.salmon": "Rå laks",
  "item.minecraft.salmon_bucket": "Spann med laks",
  "item.minecraft.salmon_spawn_egg": "Kveikjeegg fyre laks",
  "item.minecraft.scrape_pottery_sherd": "Skålbrot med øks",
  "item.minecraft.scute": "Skjold",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Vaktar-brynjepryd",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formar-brynjepryd",
  "item.minecraft.sheaf_pottery_shard": "Skålbrot med kveite",
  "item.minecraft.sheaf_pottery_sherd": "Skålbrot med kveite",
  "item.minecraft.shears": "Sòks",
  "item.minecraft.sheep_spawn_egg": "Kveikjeegg fyre saud",
  "item.minecraft.shelter_pottery_shard": "Skålbrot med tre",
  "item.minecraft.shelter_pottery_sherd": "Skålbrot med tre",
  "item.minecraft.shield": "Skjold",
  "item.minecraft.shield.black": "Svart skjold",
  "item.minecraft.shield.blue": "Blå skjold",
  "item.minecraft.shield.brown": "Brun skjold",
  "item.minecraft.shield.cyan": "Blågrøn skjold",
  "item.minecraft.shield.gray": "Grå skjold",
  "item.minecraft.shield.green": "Grøn skjold",
  "item.minecraft.shield.light_blue": "Ljosblå skjold",
  "item.minecraft.shield.light_gray": "Ljosgrå skjold",
  "item.minecraft.shield.lime": "Ljosgrøn skjold",
  "item.minecraft.shield.magenta": "Ljosblåraud skjold",
  "item.minecraft.shield.orange": "Brandgul skjold",
  "item.minecraft.shield.pink": "Ljosraud skjold",
  "item.minecraft.shield.purple": "Blåraud skjold",
  "item.minecraft.shield.red": "Raud skjold",
  "item.minecraft.shield.white": "Kvit skjold",
  "item.minecraft.shield.yellow": "Gul skjold",
  "item.minecraft.shulker_shell": "Shulkerskal",
  "item.minecraft.shulker_spawn_egg": "Kveikjeegg fyre shulker",
  "item.minecraft.sign": "Skilt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Togn-brynjepryd",
  "item.minecraft.silverfish_spawn_egg": "Kveikjeegg fyre sylvkrek",
  "item.minecraft.skeleton_horse_spawn_egg": "Kveikjeegg fyr’ øykjebeingrind",
  "item.minecraft.skeleton_spawn_egg": "Kveikjeegg fyre beingrind",
  "item.minecraft.skull_banner_pattern": "Fanemynster",
  "item.minecraft.skull_banner_pattern.desc": "Skalle",
  "item.minecraft.skull_banner_pattern.new": "Fanemynster fyre skalle",
  "item.minecraft.skull_pottery_shard": "Skålbrot med skalle",
  "item.minecraft.skull_pottery_sherd": "Skålbrot med skalle",
  "item.minecraft.slime_ball": "Slimball",
  "item.minecraft.slime_spawn_egg": "Kveikjeegg fyre sliming",
  "item.minecraft.smithing_template": "Smideskant",
  "item.minecraft.smithing_template.applies_to": "Verd nyttat på:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Legg til malmstykke elder dvergsmide",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Brynja",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Legg til brynjestykke",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Malmstykke og dvergsmide",
  "item.minecraft.smithing_template.ingredients": "Innehald:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Legg til netherittstykke",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Demantreidnad",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Legg til brynja, våpn elder ambòd av demant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittstykke",
  "item.minecraft.smithing_template.upgrade": "Betring: ",
  "item.minecraft.sniffer_spawn_egg": "Kveikjeegg fyre tevar",
  "item.minecraft.snort_pottery_shard": "Skålbrot med moldnase",
  "item.minecraft.snort_pottery_sherd": "Skålbrot med moldnase",
  "item.minecraft.snout_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Tryne-brynjepryd",
  "item.minecraft.snow_golem_spawn_egg": "Kveikjeegg fyre snjokall",
  "item.minecraft.snowball": "Snjoball",
  "item.minecraft.spectral_arrow": "Merkjekolv",
  "item.minecraft.spider_eye": "Auga av kongurvåva",
  "item.minecraft.spider_spawn_egg": "Kveikjeegg fyre kongurvåva",
  "item.minecraft.spire_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spir-brynjepryd",
  "item.minecraft.splash_potion": "Kastebrygg",
  "item.minecraft.splash_potion.effect.awkward": "Keivelegt kastebrygg",
  "item.minecraft.splash_potion.effect.empty": "Kastelegt inkje-emnande brygg",
  "item.minecraft.splash_potion.effect.fire_resistance": "Kastelegt eldvernsbrygg",
  "item.minecraft.splash_potion.effect.harming": "Kastelegt skadebrygg",
  "item.minecraft.splash_potion.effect.healing": "Kastelegt lækjebrygg",
  "item.minecraft.splash_potion.effect.infested": "Kastelegt fengjebrygg",
  "item.minecraft.splash_potion.effect.invisibility": "Kastelegt usynleikebrygg",
  "item.minecraft.splash_potion.effect.leaping": "Kastelegt byksebrygg",
  "item.minecraft.splash_potion.effect.levitation": "Kastelegt svivebrygg",
  "item.minecraft.splash_potion.effect.luck": "Kastelegt heppebrygg",
  "item.minecraft.splash_potion.effect.mundane": "Kvardagslegt kastebrygg",
  "item.minecraft.splash_potion.effect.night_vision": "Kastelegt nattarsynsbrygg",
  "item.minecraft.splash_potion.effect.oozing": "Kastelegt tytebrygg",
  "item.minecraft.splash_potion.effect.poison": "Kastelegt eiterbrygg",
  "item.minecraft.splash_potion.effect.regeneration": "Kastelegt atterskapebrygg",
  "item.minecraft.splash_potion.effect.slow_falling": "Kastelegt seinfallsbrygg",
  "item.minecraft.splash_potion.effect.slowness": "Kastelegt tråleikebrygg",
  "item.minecraft.splash_potion.effect.strength": "Kastelegt styrkjebrygg",
  "item.minecraft.splash_potion.effect.swiftness": "Kastelegt snarleikebrygg",
  "item.minecraft.splash_potion.effect.thick": "Tjukt kastebrygg",
  "item.minecraft.splash_potion.effect.turtle_master": "Kastebrygg frå skjelpoddemeistaren",
  "item.minecraft.splash_potion.effect.water": "Kasteleg vatsflaska",
  "item.minecraft.splash_potion.effect.water_breathing": "Kastelegt vatsandebrygg",
  "item.minecraft.splash_potion.effect.weakness": "Kastelegt veikjebrygg",
  "item.minecraft.splash_potion.effect.weaving": "Kastelegt vevebrygg",
  "item.minecraft.splash_potion.effect.wind_charged": "Kastelegt vindladebrygg",
  "item.minecraft.spruce_boat": "Granbåt",
  "item.minecraft.spruce_chest_boat": "Granbåt med kista",
  "item.minecraft.spyglass": "Handkikar",
  "item.minecraft.squid_spawn_egg": "Kveikjeegg fyre spruta",
  "item.minecraft.stick": "Pinne",
  "item.minecraft.stone_axe": "Steinøks",
  "item.minecraft.stone_hoe": "Steingrev",
  "item.minecraft.stone_pickaxe": "Steinhakka",
  "item.minecraft.stone_shovel": "Steinspade",
  "item.minecraft.stone_spear": "Steinspjot",
  "item.minecraft.stone_sword": "Steinsverd",
  "item.minecraft.stray_spawn_egg": "Kveikjeegg fyre villegrind",
  "item.minecraft.strider_spawn_egg": "Kveikjeegg fyre stìgar",
  "item.minecraft.string": "Tråd",
  "item.minecraft.sugar": "Sukker",
  "item.minecraft.suspicious_stew": "Tvilsam gryterett",
  "item.minecraft.sweet_berries": "Søtber",
  "item.minecraft.tadpole_bucket": "Rovetrollspann",
  "item.minecraft.tadpole_spawn_egg": "Kveikjeegg fyre rovetroll",
  "item.minecraft.tide_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tidvats-brynjepryd",
  "item.minecraft.tipped_arrow": "Duvad kolv",
  "item.minecraft.tipped_arrow.effect.awkward": "Duvad kolv",
  "item.minecraft.tipped_arrow.effect.empty": "Ikkje-emnande duvad kolv",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Eldvernskolv",
  "item.minecraft.tipped_arrow.effect.harming": "Skadekolv",
  "item.minecraft.tipped_arrow.effect.healing": "Lækjekolv",
  "item.minecraft.tipped_arrow.effect.infested": "Fengjekolv",
  "item.minecraft.tipped_arrow.effect.invisibility": "Usynleikekolv",
  "item.minecraft.tipped_arrow.effect.leaping": "Byksekolv",
  "item.minecraft.tipped_arrow.effect.levitation": "Svivekolv",
  "item.minecraft.tipped_arrow.effect.luck": "Heppekolv",
  "item.minecraft.tipped_arrow.effect.mundane": "Duvad kolv",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nattarsynskolv",
  "item.minecraft.tipped_arrow.effect.oozing": "Tytekolv",
  "item.minecraft.tipped_arrow.effect.poison": "Eiterkolv",
  "item.minecraft.tipped_arrow.effect.regeneration": "Atterskapekolv",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Seinfallskolv",
  "item.minecraft.tipped_arrow.effect.slowness": "Tråleikekolv",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkjekolv",
  "item.minecraft.tipped_arrow.effect.swiftness": "Snarleikekolv",
  "item.minecraft.tipped_arrow.effect.thick": "Duvad kolv",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pil frå skjelpoddemeistaren",
  "item.minecraft.tipped_arrow.effect.water": "Pil med kasteleg-verknad",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vatsandekolv",
  "item.minecraft.tipped_arrow.effect.weakness": "Veikjekolv",
  "item.minecraft.tipped_arrow.effect.weaving": "Vevekolv",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindladekolv",
  "item.minecraft.tnt_minecart": "Malmvogn med TNT",
  "item.minecraft.torchflower_seeds": "Frjo av kyndelblom",
  "item.minecraft.totem_of_undying": "Totem mot døying",
  "item.minecraft.trader_llama_spawn_egg": "Kveikjeegg fyre kaupmannslama",
  "item.minecraft.trial_key": "Røynelykel",
  "item.minecraft.trident": "Ljoster",
  "item.minecraft.tropical_fish": "Sudhavsfisk",
  "item.minecraft.tropical_fish_bucket": "Sudhavsfiskespann",
  "item.minecraft.tropical_fish_spawn_egg": "Kveikjeegg fyre sudhavsfisk",
  "item.minecraft.turtle_helmet": "Skjelpoddeskal",
  "item.minecraft.turtle_scute": "Skjelpoddeskjold",
  "item.minecraft.turtle_spawn_egg": "Kveikjeegg fyre skjelpodda",
  "item.minecraft.vex_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Mødar-brynjepryd",
  "item.minecraft.vex_spawn_egg": "Kveikjeegg fyre mødar",
  "item.minecraft.villager_spawn_egg": "Kveikjeegg fyre bygdarbue",
  "item.minecraft.vindicator_spawn_egg": "Kveikjeegg fyr’ hævdar",
  "item.minecraft.wandering_trader_spawn_egg": "Kveikjeegg fyre farande kaupmann",
  "item.minecraft.ward_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Vord-brynjepryd",
  "item.minecraft.warden_spawn_egg": "Kveikjeegg fyre vord",
  "item.minecraft.warped_fungus_on_a_stick": "Vrìdsopp på stong",
  "item.minecraft.water_bucket": "Vatsspann",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vegfinnar-brynjepryd",
  "item.minecraft.wheat": "Kveite",
  "item.minecraft.wheat_seeds": "Kveitefrjo",
  "item.minecraft.white_bundle": "Kvit sekk",
  "item.minecraft.white_dye": "Kvitt lìtemne",
  "item.minecraft.white_harness": "Kvitt selety",
  "item.minecraft.wild_armor_trim_smithing_template": "Smideskant",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vill brynjepryd",
  "item.minecraft.wind_charge": "Vindlading",
  "item.minecraft.witch_spawn_egg": "Kveikjeegg fyre trollkjerring",
  "item.minecraft.wither_skeleton_spawn_egg": "Kveikjeegg fyre witherbeingrind",
  "item.minecraft.wither_spawn_egg": "Kveikjeegg fyre wither",
  "item.minecraft.wolf_armor": "Ulvebrynja",
  "item.minecraft.wolf_spawn_egg": "Kveikjeegg fyr’ ulv",
  "item.minecraft.wooden_axe": "Treøks",
  "item.minecraft.wooden_hoe": "Tregrev",
  "item.minecraft.wooden_pickaxe": "Trehakka",
  "item.minecraft.wooden_shovel": "Trespade",
  "item.minecraft.wooden_spear": "Trespjot",
  "item.minecraft.wooden_sword": "Tresverd",
  "item.minecraft.writable_book": "Bok og fjøderpenn",
  "item.minecraft.written_book": "Skrivi bok",
  "item.minecraft.yellow_bundle": "Gul sekk",
  "item.minecraft.yellow_dye": "Gult lìtemne",
  "item.minecraft.yellow_harness": "Gult selety",
  "item.minecraft.zoglin_spawn_egg": "Kveikjeegg fyre zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Kveikjeegg fyr’ øykjenåe",
  "item.minecraft.zombie_nautilus_spawn_egg": "Kveikjeegg fyre perlebåtnåe",
  "item.minecraft.zombie_spawn_egg": "Kveikjeegg fyre nåe",
  "item.minecraft.zombie_villager_spawn_egg": "Kveikjeegg fyre bygdarnåe",
  "item.minecraft.zombified_piglin_spawn_egg": "Kveikjeegg fyre piglinnåe"
}
export const hn_no = items; 
